<template>
  <div>
    <validation-observer
      ref="serviceRequestFormSave"
    >
      <b-form @submit.prevent="submitSaveForm">
        <b-row
          class="content-header v-sticky-sidebar-container service_request_task collapse__form-wrapper"
          :class="{ 'white-background': !editFormInOtherStatus, 'green-background': editFormInOtherStatus }"
          style="border-radius: 6px;"
        >
          <!-- Content Left -->
          <b-col
            class="content-header-left my-1 top-info-right"
            cols="12"
            md="3"
          >
            <div
              class="user_block ac_type"
              style="float: none;"
            >
              <div class="user_avatar" />
              <div class="user_info">
                <h6>Status</h6>
                <h5 class="">
                  {{ requestForm.status }}
                </h5>
              </div>
            </div>

            <b-card
              v-if="editFormInOtherStatus"
              class="mt-2 service-forms-card success-card"
            >
              <template #header>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="button"
                  variant="flat-primary"
                  class="primary-button-with-background mr-3"
                >
                  <feather-icon
                    icon="FeatherIcon"
                    class=""
                    size="20"
                    style="color: #fff;"
                  />
                </b-button>
                <h3 class="align-middle mr-auto">
                  <span class="step-class">you're now</span>
                  Editing this form
                </h3>
              </template>
              <b-card-text
                class="signing-stage__title"
              >
                <span>After submitting the signed form, the system will generate a signed PDF copy and email to customer.</span>
              </b-card-text>
            </b-card>

            <app-collapse
              v-if="requestForm.status == 'To prepare' || editFormInOtherStatus"
              accordion
              class="mt-2 service-form-collapse"
            >
              <app-collapse-item
                ref="redemptionDetailsRef"
                title="Redemption Details"
                class="custom-collapse-icon"
                :is-visible="redemptionCollapse"
              >
                <template
                  #header
                >
                  <b-row
                    class="full-width"
                  >
                    <!-- Content Left -->
                    <b-col
                      class="content-header-left"
                      cols="12"
                      md="12"
                    >
                      <span style="color: #FFF;">Redemption Details</span>
                    </b-col>
                  </b-row>
                </template>
                <b-row
                  class=""
                >
                  <b-col
                    class="content-header-left"
                    cols="12"
                    md="12"
                  >
                    <b-form-group
                      label-class="field-label label-required-star"
                      label="Niche Lot"
                      label-for="nicheLot"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Niche Lot"
                        vid="nicheLot"
                        rules="required"
                      >
                        <b-form-input
                          id="nicheLot"
                          ref="nicheLot"
                          v-model="nicheLot"
                          placeholder="Enter"
                          :state="(errors.length > 0) ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                    class="content-header-left"
                    cols="12"
                    md="12"
                  >
                    <b-form-group
                      label-class="field-label label-required-star"
                      label="Number of Unit"
                      label-for="numberOfUnit"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Number of Unit"
                        vid="numberOfUnit"
                        rules="required"
                      >
                        <b-form-input
                          id="numberOfUnit"
                          ref="numberOfUnit"
                          v-model="numberOfUnit"
                          placeholder="Enter"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                    class="content-header-left"
                    cols="12"
                    md="12"
                  >
                    <b-form-group
                      label-class="field-label label-required-star"
                      label="File No. 文件号码"
                      label-for="fileNo"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="File No."
                        vid="fileNo"
                        rules="required"
                      >
                        <b-form-input
                          id="fileNo"
                          ref="fileNo"
                          v-model="fileNo"
                          placeholder="Enter"
                          :state="(errors.length > 0) ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                    class="content-header-left"
                    cols="12"
                    md="12"
                  >
                    <b-form-group
                      label-class="field-label"
                      label="Urn File No."
                      label-for="urnFileNo"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Urn File No."
                        vid="urnFileNo"
                        rules=""
                      >
                        <b-form-input
                          id="urnFileNo"
                          ref="urnFileNo"
                          v-model="urnFileNo"
                          placeholder="Enter"
                          :state="(errors.length > 0) ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                    class="content-header-left"
                    cols="12"
                    md="12"
                  >
                    <b-form-group
                      label-class="field-label"
                      label="Related File Number"
                      label-for="relatedFileNo"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Urn File No."
                        vid="relatedFileNo"
                        rules=""
                      >
                        <b-form-input
                          id="relatedFileNo"
                          ref="relatedFileNo"
                          v-model="relatedFileNo"
                          placeholder="Enter"
                          :state="(errors.length > 0) ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
              </app-collapse-item>
              <app-collapse-item
                ref="purchaserDetailsRef"
                title="Purchaser Details"
                class="custom-collapse-icon"
                :is-visible="purchaserCollapse"
              >
                <template
                  #header
                >
                  <b-row
                    class="full-width"
                  >
                    <!-- Content Left -->
                    <b-col
                      class="content-header-left"
                      cols="12"
                      md="12"
                    >
                      <span style="color: #FFF;">Purchaser Details</span>
                    </b-col>
                  </b-row>
                </template>
                <b-row
                  class=""
                >
                  <b-col
                    class="content-header-left"
                    cols="12"
                    md="12"
                  >
                    <div>
                      <span class="field-label label-required-star">I as Purchaser/authorized representative</span>
                    </div>
                    <b-form-group
                      v-if="currentCustomerNameType == 'input'"
                      label=""
                      label-for="input-default"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Representative"
                        rules="required"
                      >
                        <b-form-input
                          id="input-default"
                          ref="customerName"
                          v-model="customerName"
                          placeholder="Enter"
                          :state="(errors.length > 0) ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                    <div
                      v-else
                      style="border-radius: 5px;
                            border: 1px solid #000; padding: 8px; height: 120px"
                      class="my-75"
                      :class="{ 'rounded-error': customerNameImageError }"
                    >
                      <div class="d-flex justify-content-between">
                        <span>Handwriting 手写</span>
                        <feather-icon
                          icon="XIcon"
                          class="ml-auto"
                          size="16"
                          @click="changeCustomerNameInput('input')"
                        />
                      </div>
                      <img
                        v-if="customerNameImage"
                        v-b-modal.customer-name-modal
                        :src="customerNameImage"
                        class="w-100 signature-image"
                        alt="sign"
                        fluid
                      >
                    </div>

                    <div
                      v-if="currentCustomerNameType == 'input'"
                      class="d-flex justify-content-between"
                      @click="changeCustomerNameInput('canvas')"
                    >
                      <span style="color: #104D9D">Use handwriting instead</span>
                      <b-button
                        variant="link"
                        class="pt-0 pr-0"
                      >
                        <feather-icon
                          icon="Edit3Icon"
                          class="ml-auto"
                          size="16"
                        />
                      </b-button>
                    </div>
                    <div
                      v-else
                      class="d-flex justify-content-between"
                      @click="changeCustomerNameInput('input')"
                    >
                      <span style="color: #104D9D">Use keyboard instead</span>
                      <b-button
                        variant="link"
                        class="pt-0 pr-0"
                      >
                        <feather-icon
                          icon="Edit3Icon"
                          class="ml-auto"
                          size="16"
                        />
                      </b-button>
                    </div>
                  </b-col>
                  <b-col
                    class="content-header-left"
                    cols="12"
                    md="12"
                  >
                    <b-form-group
                      label-class="field-label label-required-star"
                      label="NRIC"
                      label-for="customerNRIC"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="NRIC"
                        vid="customerNRIC"
                        rules="required"
                      >
                        <b-form-input
                          id="customerNRIC"
                          ref="customerNRIC"
                          v-model="customerNRIC"
                          placeholder="Enter"
                          :state="(errors.length > 0) ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
              </app-collapse-item>
              <app-collapse-item
                ref="kinDetailsRef"
                title="Next of Kin Details"
                class="custom-collapse-icon"
                :is-visible="kinCollapse"
              >
                <template
                  #header
                >
                  <b-row
                    class="full-width"
                  >
                    <!-- Content Left -->
                    <b-col
                      class="content-header-left"
                      cols="12"
                      md="12"
                    >
                      <span style="color: #FFF;">Next of Kin Details</span>
                    </b-col>
                  </b-row>
                </template>
                <b-row
                  class=""
                >
                  <b-col
                    class="content-header-left"
                    cols="12"
                    md="12"
                  >
                    <div>
                      <span class="field-label">I as Next of Kin</span>
                    </div>
                    <b-form-group
                      v-if="currentKinNameType == 'input'"
                      label=""
                      label-for="input-default"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="I as Next of Kin"
                        rules=""
                      >
                        <b-form-input
                          id="input-default"
                          ref="kinName"
                          v-model="kinName"
                          placeholder="Enter"
                          :state="(errors.length > 0) ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                    <div
                      v-else
                      style="border-radius: 5px;
                            border: 1px solid #000; padding: 8px; height: 120px"
                      class="my-75"
                      :class="{ 'rounded-error': kinNameImageError }"
                    >
                      <div class="d-flex justify-content-between">
                        <span>Handwriting 手写</span>
                        <feather-icon
                          icon="XIcon"
                          class="ml-auto"
                          size="16"
                          @click="changeKinNameInput('input')"
                        />
                      </div>
                      <img
                        v-if="kinNameImage"
                        v-b-modal.kin-name-modal
                        :src="kinNameImage"
                        class="w-100 signature-image"
                        alt="sign"
                        fluid
                      >
                    </div>

                    <div
                      v-if="currentKinNameType == 'input'"
                      class="d-flex justify-content-between"
                      @click="changeKinNameInput('canvas')"
                    >
                      <span style="color: #104D9D">Use handwriting instead</span>
                      <b-button
                        variant="link"
                        class="pt-0 pr-0"
                      >
                        <feather-icon
                          icon="Edit3Icon"
                          class="ml-auto"
                          size="16"
                        />
                      </b-button>
                    </div>
                    <div
                      v-else
                      class="d-flex justify-content-between"
                      @click="changeKinNameInput('input')"
                    >
                      <span style="color: #104D9D">Use keyboard instead</span>
                      <b-button
                        variant="link"
                        class="pt-0 pr-0"
                      >
                        <feather-icon
                          icon="Edit3Icon"
                          class="ml-auto"
                          size="16"
                        />
                      </b-button>
                    </div>
                  </b-col>
                  <b-col
                    class="content-header-left"
                    cols="12"
                    md="12"
                  >
                    <b-form-group
                      label-class="field-label"
                      label="NRIC"
                      label-for="kinNRIC"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="NRIC"
                        vid="kinNRIC"
                        rules=""
                      >
                        <b-form-input
                          id="kinNRIC"
                          ref="kinNRIC"
                          v-model="kinNRIC"
                          placeholder="Enter"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
              </app-collapse-item>
              <app-collapse-item
                ref="urnDetailsRef"
                title="Urn Retrieval Record"
                class="custom-collapse-icon"
                :is-visible="urnCollapse"
              >
                <template
                  #header
                >
                  <b-row
                    class="full-width"
                  >
                    <!-- Content Left -->
                    <b-col
                      class="content-header-left"
                      cols="12"
                      md="12"
                    >
                      <span style="color: #FFF;">Urn Retrieval Record</span>
                    </b-col>
                  </b-row>
                </template>
                <b-row
                  class=""
                >
                  <b-col
                    class="content-header-left"
                    cols="12"
                    md="12"
                  >
                    <b-alert
                      v-if="hasIR"
                      variant="warning"
                      class=""
                      show
                    >
                      <div
                        v-if="new Date(serviceRequest.createdAt).setHours(0, 0, 0, 0) < new Date(2024,4,28).setHours(0, 0, 0, 0) && !scrollSection"
                        class="alert-body d-flex"
                      >
                        <feather-icon
                          icon="AlertCircleIcon"
                          size="44"
                          class="mt-3 mr-1"
                        />
                        <div>
                          <p class="weight-400">
                            You can edit this by editing the related Inventory Requests.
                            <a @click="manualIRIntegration"><u>Manually integrate form with IR workflow</u></a>
                          </p>
                          <p class="weight-400">
                            The records in this table is synchronized from the related Inventory Requests within this Service Request.
                          </p>
                        </div>
                      </div>
                      <div
                        v-else
                        class="alert-body d-flex"
                      >
                        <feather-icon
                          icon="AlertCircleIcon"
                          size="54"
                          class="mt-2 mr-1"
                        />
                        <span class="weight-400">You can edit this by editing the related Inventory Requests. The records in this table is synchronized from the related Inventory Requests within this Service Request.</span>
                      </div>
                    </b-alert>
                    <b-alert
                      v-else
                      variant="success"
                      class=""
                      show
                    >
                      <div
                        v-if="new Date(serviceRequest.createdAt).setHours(0, 0, 0, 0) < new Date(2024,4,28).setHours(0, 0, 0, 0) && !scrollSection"
                        class="alert-body d-flex"
                      >
                        <feather-icon
                          icon="AlertCircleIcon"
                          size="54"
                          class="mt-11 mr-1"
                        />
                        <span class="weight-400">Please <a @click="manualIRIntegration"><u>Manually integrate form with IR workflow</u></a> and create an <strong>Inventory Request</strong> for this part so that the urn record will be updated in this form.</span>
                      </div>
                      <div
                        v-else
                        class="alert-body d-flex"
                      >
                        <feather-icon
                          icon="AlertCircleIcon"
                          size="32"
                          class="mt-2 mr-1"
                        />
                        <span class="weight-400">Please create an <strong>Inventory Request</strong> for this part so that the urn record will be updated in this form.</span>
                      </div>
                    </b-alert>
                    <b-button
                      variant="outline-primary"
                      :to="{ name: 'operation-service-requests-show', params: { id: serviceRequest._id }, query: { section: scrollSection } }"
                      class=""
                    >
                      <span>Go to Inventory Request (Urn)</span>
                      <feather-icon
                        icon="ArrowRightIcon"
                        class="ml-50"
                        size="16"
                      />
                    </b-button>
                  </b-col>
                  <!-- <b-col
                    class="content-header-left"
                    cols="12"
                    md="12"
                  >
                    <b-form-group
                      label-class="field-label"
                      label=""
                      label-for="dgcwbs"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="dgcwbs"
                        vid="dgcwbs"
                        rules=""
                      >
                        <b-form-checkbox
                          id="dgcwbs"
                          ref="dgcwbs"
                          v-model="dgcwbs"
                          name="dgcwbs"
                          value="dgcwbs"
                          @input="clearQuantity('dgcwbs')"
                        >
                          Deep Green Crystal with Buddhist Sutra 心若彼岸 （深青琉璃经文罐）
                        </b-form-checkbox>
                        <div
                          v-if="dgcwbs"
                          style="padding-left: 1.8rem;"
                        >
                          <div
                            class="sd-single-service-description"
                          >
                            <p>NMG</p>
                            <b-form-spinbutton
                              v-model="dgcwbsNmg"
                              inline
                              class="spin-button-sd"
                              step="1"
                              min="0"
                            />
                          </div>
                          <div
                            class="sd-single-service-description"
                          >
                            <p>MPL</p>
                            <b-form-spinbutton
                              v-model="dgcwbsMpl"
                              inline
                              class="spin-button-sd"
                              step="1"
                              min="0"
                            />
                          </div>
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                    class="content-header-left"
                    cols="12"
                    md="12"
                  >
                    <b-form-group
                      label-class="field-label"
                      label=""
                      label-for="lgcwbs"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="lgcwbs"
                        vid="lgcwbs"
                        rules=""
                      >
                        <b-form-checkbox
                          id="lgcwbs"
                          ref="lgcwbs"
                          v-model="lgcwbs"
                          name="lgcwbs"
                          value="lgcwbs"
                          @input="clearQuantity('lgcwbs')"
                        >
                          Light Green Crystal with Buddhist Sutra 心若彼岸 （浅青琉璃经文罐）
                        </b-form-checkbox>
                        <div
                          v-if="lgcwbs"
                          style="padding-left: 1.8rem;"
                        >
                          <div
                            class="sd-single-service-description"
                          >
                            <p>NMG</p>
                            <b-form-spinbutton
                              v-model="lgcwbsNmg"
                              inline
                              class="spin-button-sd"
                              step="1"
                              min="0"
                            />
                          </div>
                          <div
                            class="sd-single-service-description"
                          >
                            <p>MPL</p>
                            <b-form-spinbutton
                              v-model="lgcwbsMpl"
                              inline
                              class="spin-button-sd"
                              step="1"
                              min="0"
                            />
                          </div>
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                    class="content-header-left"
                    cols="12"
                    md="12"
                  >
                    <b-form-group
                      label-class="field-label"
                      label=""
                      label-for="lcwbs"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="lcwbs"
                        vid="lcwbs"
                        rules=""
                      >
                        <b-form-checkbox
                          id="lcwbs"
                          ref="lcwbs"
                          v-model="lcwbs"
                          name="lcwbs"
                          value="lcwbs"
                          @input="clearQuantity('lcwbs')"
                        >
                          Lavender Crystal with Buddhist Sutra 紫罗兰琉璃经文罐
                        </b-form-checkbox>
                        <div
                          v-if="lcwbs"
                          style="padding-left: 1.8rem;"
                        >
                          <div
                            class="sd-single-service-description"
                          >
                            <p>NMG</p>
                            <b-form-spinbutton
                              v-model="lcwbsNmg"
                              inline
                              class="spin-button-sd"
                              step="1"
                              min="0"
                            />
                          </div>
                          <div
                            class="sd-single-service-description"
                          >
                            <p>MPL</p>
                            <b-form-spinbutton
                              v-model="lcwbsMpl"
                              inline
                              class="spin-button-sd"
                              step="1"
                              min="0"
                            />
                          </div>
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                    class="content-header-left"
                    cols="12"
                    md="12"
                  >
                    <b-form-group
                      label-class="field-label"
                      label=""
                      label-for="pcll"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="pcll"
                        vid="pcll"
                        rules=""
                      >
                        <b-form-checkbox
                          id="pcll"
                          ref="pcll"
                          v-model="pcll"
                          name="pcll"
                          value="pcll"
                          @input="clearQuantity('pcll')"
                        >
                          Pink Crystal Liu Li 粉红晶琉璃罐
                        </b-form-checkbox>
                        <div
                          v-if="pcll"
                          style="padding-left: 1.8rem;"
                        >
                          <div
                            class="sd-single-service-description"
                          >
                            <p>NMG</p>
                            <b-form-spinbutton
                              v-model="pcllNmg"
                              inline
                              class="spin-button-sd"
                              step="1"
                              min="0"
                            />
                          </div>
                          <div
                            class="sd-single-service-description"
                          >
                            <p>MPL</p>
                            <b-form-spinbutton
                              v-model="pcllMpl"
                              inline
                              class="spin-button-sd"
                              step="1"
                              min="0"
                            />
                          </div>
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                    class="content-header-left"
                    cols="12"
                    md="12"
                  >
                    <b-form-group
                      label-class="field-label"
                      label=""
                      label-for="byll"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="byll"
                        vid="byll"
                        rules=""
                      >
                        <b-form-checkbox
                          id="byll"
                          ref="byll"
                          v-model="byll"
                          name="byll"
                          value="byll"
                          @input="clearQuantity('byll')"
                        >
                          Beeswax Yellow Liu Li 蜜蜡黄琉璃罐
                        </b-form-checkbox>
                        <div
                          v-if="byll"
                          style="padding-left: 1.8rem;"
                        >
                          <div
                            class="sd-single-service-description"
                          >
                            <p>NMG</p>
                            <b-form-spinbutton
                              v-model="byllNmg"
                              inline
                              class="spin-button-sd"
                              step="1"
                              min="0"
                            />
                          </div>
                          <div
                            class="sd-single-service-description"
                          >
                            <p>MPL</p>
                            <b-form-spinbutton
                              v-model="byllMpl"
                              inline
                              class="spin-button-sd"
                              step="1"
                              min="0"
                            />
                          </div>
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                    class="content-header-left"
                    cols="12"
                    md="12"
                  >
                    <b-form-group
                      label-class="field-label"
                      label=""
                      label-for="ro"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="ro"
                        vid="ro"
                        rules=""
                      >
                        <b-form-checkbox
                          id="ro"
                          ref="ro"
                          v-model="ro"
                          name="ro"
                          value="ro"
                          @input="clearQuantity('ro')"
                        >
                          Red Onyx 写意人生（红玉罐）
                        </b-form-checkbox>
                        <div
                          v-if="ro"
                          style="padding-left: 1.8rem;"
                        >
                          <div
                            class="sd-single-service-description"
                          >
                            <p>NMG</p>
                            <b-form-spinbutton
                              v-model="roNmg"
                              inline
                              class="spin-button-sd"
                              step="1"
                              min="0"
                            />
                          </div>
                          <div
                            class="sd-single-service-description"
                          >
                            <p>MPL</p>
                            <b-form-spinbutton
                              v-model="roMpl"
                              inline
                              class="spin-button-sd"
                              step="1"
                              min="0"
                            />
                          </div>
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                    class="content-header-left"
                    cols="12"
                    md="12"
                  >
                    <b-form-group
                      label-class="field-label"
                      label=""
                      label-for="pj"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="pj"
                        vid="pj"
                        rules=""
                      >
                        <b-form-checkbox
                          id="pj"
                          ref="pj"
                          v-model="pj"
                          name="pj"
                          value="pj"
                          @input="clearQuantity('pj')"
                        >
                          Poppy Jade 芙蓉西施玉（芙蓉玉罐）
                        </b-form-checkbox>
                        <div
                          v-if="pj"
                          style="padding-left: 1.8rem;"
                        >
                          <div
                            class="sd-single-service-description"
                          >
                            <p>NMG</p>
                            <b-form-spinbutton
                              v-model="pjNmg"
                              inline
                              class="spin-button-sd"
                              step="1"
                              min="0"
                            />
                          </div>
                          <div
                            class="sd-single-service-description"
                          >
                            <p>MPL</p>
                            <b-form-spinbutton
                              v-model="pjMpl"
                              inline
                              class="spin-button-sd"
                              step="1"
                              min="0"
                            />
                          </div>
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                    class="content-header-left"
                    cols="12"
                    md="12"
                  >
                    <b-form-group
                      label-class="field-label"
                      label=""
                      label-for="rj"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="rj"
                        vid="rj"
                        rules=""
                      >
                        <b-form-checkbox
                          id="rj"
                          ref="rj"
                          v-model="rj"
                          name="rj"
                          value="rj"
                          @input="clearQuantity('rj')"
                        >
                          Royalty Jade 皇家白玉
                        </b-form-checkbox>
                        <div
                          v-if="rj"
                          style="padding-left: 1.8rem;"
                        >
                          <div
                            class="sd-single-service-description"
                          >
                            <p>NMG</p>
                            <b-form-spinbutton
                              v-model="rjNmg"
                              inline
                              class="spin-button-sd"
                              step="1"
                              min="0"
                            />
                          </div>
                          <div
                            class="sd-single-service-description"
                          >
                            <p>MPL</p>
                            <b-form-spinbutton
                              v-model="rjMpl"
                              inline
                              class="spin-button-sd"
                              step="1"
                              min="0"
                            />
                          </div>
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                    class="content-header-left"
                    cols="12"
                    md="12"
                  >
                    <b-form-group
                      label-class="field-label"
                      label=""
                      label-for="others"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="others"
                        vid="others"
                        rules=""
                      >
                        <b-form-checkbox
                          id="others"
                          ref="others"
                          v-model="others"
                          name="others"
                          value="others"
                          @input="clearQuantity('others')"
                        >
                          Others 其他
                        </b-form-checkbox>
                        <div
                          v-if="others"
                          style="padding-left: 1.8rem;"
                        >
                          <b-form-group
                            label-class="field-label"
                            label=""
                            label-for="othersName"
                          >
                            <validation-provider
                              name="othersName"
                              vid="othersName"
                              rules=""
                            >
                              <b-form-textarea
                                id="othersName"
                                ref="othersName"
                                v-model="othersName"
                                rows="3"
                                placeholder="Enter"
                              />
                            </validation-provider>
                          </b-form-group>
                          <div
                            class="sd-single-service-description"
                          >
                            <p>NMG</p>
                            <b-form-spinbutton
                              v-model="othersNmg"
                              inline
                              class="spin-button-sd"
                              step="1"
                              min="0"
                            />
                          </div>
                          <div
                            class="sd-single-service-description"
                          >
                            <p>MPL</p>
                            <b-form-spinbutton
                              v-model="othersMpl"
                              inline
                              class="spin-button-sd"
                              step="1"
                              min="0"
                            />
                          </div>
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col> -->
                </b-row>
              </app-collapse-item>
            </app-collapse>
            <div v-if="!editFormInOtherStatus">
              <b-card
                v-if="requestForm.status == 'Ready to sign'"
                class="mt-2 service-forms-card"
              >
                <template #header>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="button"
                    variant="flat-primary"
                    class="primary-button-with-background mr-3"
                  >
                    <feather-icon
                      icon="FeatherIcon"
                      class=""
                      size="20"
                      style="color: #fff;"
                    />
                  </b-button>
                  <h3 class="align-middle mr-auto">
                    <span class="step-class">signing required</span>
                    Ready to Sign?
                  </h3>
                </template>
                <b-card-text
                  class="signing-stage__title"
                >
                  <span>If you're prepared to proceed, please press the button to indicate your agreement to this form.</span>
                </b-card-text>

                <!-- Button: Send Invoice -->
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="success"
                  class="mb-75"
                  block
                  @click="startSignProcess"
                >
                  <feather-icon
                    icon="FeatherIcon"
                    class="mr-50"
                    size="16"
                  />
                  <span class="align-middle">Sign now</span>
                </b-button>
              </b-card>
              <b-card
                v-if="requestForm.status == 'Signing'"
                class="mt-2 service-forms-card"
              >
                <template #header>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="button"
                    variant="flat-primary"
                    class="primary-button-with-background mr-3"
                  >
                    <feather-icon
                      icon="FeatherIcon"
                      class=""
                      size="20"
                      style="color: #fff;"
                    />
                  </b-button>
                  <h3 class="align-middle mr-auto">
                    <span class="step-class">signing required</span>
                    Start signing
                  </h3>
                </template>
                <b-card-text
                  class="signing-stage__title"
                >
                  <span>This form requires 2 signatures from:</span>
                </b-card-text>

                <app-timeline class="sign-list">
                  <app-timeline-item
                    v-if="isPurchaserSign"
                    title="Purchaser’s / Next of Kin’s Signatory & Date"
                    icon="CheckIcon"
                    variant="primary"
                    class="signed"
                  />
                  <app-timeline-item
                    v-else
                    title="Purchaser’s / Next of Kin’s Signatory & Date"
                    icon="FeatherIcon"
                    variant="primary"
                  />
                  <app-timeline-item
                    v-if="verifiedSign"
                    title="Verified By"
                    icon="CheckIcon"
                    variant="primary"
                    class="signed"
                  />
                  <app-timeline-item
                    v-else
                    title="Verified By"
                    icon="FeatherIcon"
                    variant="primary"
                  />
                </app-timeline>

                <hr class="dividerHR signing-stage__divider">

                <b-card-text
                  class="mt-2"
                >
                  <span>After submitted the signed form, the system will generate a PDF copy and email to customer.</span>
                </b-card-text>
              </b-card>

              <b-card
                v-if="requestForm.status == 'Signed and Sent'"
                class="mt-2 service-forms-card"
              >
                <b-card-text
                  class="signing-stage__title"
                >
                  <span>This form requires 2 signatures from:</span>
                </b-card-text>

                <app-timeline class="sign-list">
                  <app-timeline-item
                    title="Purchaser’s / Next of Kin’s Signatory & Date"
                    icon="CheckIcon"
                    variant="primary"
                    class="signed"
                  />
                  <app-timeline-item
                    title="Verified By"
                    icon="CheckIcon"
                    variant="primary"
                    class="signed"
                  />
                </app-timeline>

                <hr class="dividerHR signing-stage__divider">

                <b-card-text
                  class="mt-2"
                >
                  <b-button
                    variant="outline-primary"
                    class="w-100"
                    @click="resendSignedFormModal"
                  >
                    <feather-icon
                      icon="SendIcon"
                      class="mr-50"
                      size="16"
                    />
                    <span>Resend signed form</span>
                  </b-button>
                </b-card-text>
              </b-card>
            </div>
            <div class="d-form__action-btn">
              <b-button
                variant="outline-primary"
                class="mt-2"
                style="background: #FFF;"
                :to="{ name: 'operation-service-requests-show', params: { id: serviceRequest._id } }"
              >
                <feather-icon
                  icon="ChevronLeftIcon"
                  class="mr-50"
                  size="16"
                />
                <span>Return to {{ serviceRequest.stringID }}</span>
              </b-button>
              <b-button
                v-if="!editFormInOtherStatus && requestForm.status != 'To prepare'"
                variant="outline-primary"
                class="mt-2 ml-auto"
                style="background: #FFF;"
                @click="editForm"
              >
                <feather-icon
                  icon="EditIcon"
                  size="16"
                />
              </b-button>
            </div>
          </b-col>
          <b-col
            class="content-header-right my-1 d-md-block"
            style="position: relative;"
            md="9"
            cols="12"
          >
            <!-- Table Container Card -->
            <b-card
              no-body
              class="mb-0"
            >
              <div class="urn-form-wrapper d-form_wrapper__adjust-margin">
                <div class="orn-form-header d-flex justify-content-between mb-75">
                  <div class="d-form-logo_section" />
                  <div class="d-form-no_section text-right">
                    <h5>
                      {{ digitalForm.formNumber }}
                    </h5>
                    <h5>
                      {{ digitalForm.revision }}
                    </h5>
                  </div>
                </div>
                <div class="urn-repository-order_section">
                  <div class="b-form-section-title my-2">
                    <h3>redemption of imported urn form 领取特定骨瓮声明</h3>
                  </div>
                  <b-row>
                    <b-col md="12">
                      <b-form-group
                        label-class="label-width-340"
                        label-cols="12"
                        label-cols-md="6"
                        label-cols-lg="4"
                        label="REDEMPTION OF IMPORTED URN (NICHE LOT)*:"
                        label-for="input-default"
                        class="align-items-center"
                      >
                        <div
                          class="empty-input__text"
                          :class="{ 'bg-white': (requestForm.status != 'To prepare' || nicheLot), 'edit-mode': editFormInOtherStatus }"
                          @click="handleClick('nicheLot', 'redemptionDetailsRef')"
                        >
                          <p
                            v-if="(requestForm.status == 'To prepare' || editFormInOtherStatus) && !nicheLot"
                            class="placeholder__text"
                          />
                          <p v-else>
                            {{ nicheLot || '-' }}
                          </p>
                        </div>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4">
                      <b-form-group
                        label-cols="12"
                        label-cols-md="3"
                        label-cols-lg="2"
                        label="I*,"
                        label-for="input-default"
                        class="align-items-center"
                      >
                        <div
                          v-if="currentCustomerNameType == 'input'"
                          class="empty-input__text"
                          :class="{ 'bg-white': (requestForm.status != 'To prepare' || customerName), 'edit-mode': editFormInOtherStatus }"
                          @click="handleClick('customerName', 'purchaserDetailsRef')"
                        >
                          <p
                            v-if="(requestForm.status == 'To prepare' || editFormInOtherStatus) && !customerName"
                            class="placeholder__text"
                          />
                          <p v-else>
                            {{ customerName || '-' }}
                          </p>
                        </div>
                        <div
                          v-else
                          :class="{ 'signed': customerNameImage }"
                          style="border-bottom: 1px solid #000"
                        >
                          <b-img
                            v-if="customerNameImage"
                            :src="customerNameImage"
                            class="w-100 signature-image"
                            alt="sign"
                          />
                        </div>
                      </b-form-group>
                    </b-col>
                    <b-col md="8">
                      <b-form-group
                        label-class="label-width-340"
                        label-cols="12"
                        label-cols-md="6"
                        label-cols-lg="4"
                        label="Purchaser/authorized representative (NRIC:)* "
                        label-for="input-default"
                        class="align-items-center"
                      >
                        <div
                          class="empty-input__text"
                          :class="{ 'bg-white': (requestForm.status != 'To prepare' || customerNRIC), 'edit-mode': editFormInOtherStatus }"
                          @click="handleClick('customerNRIC', 'purchaserDetailsRef')"
                        >
                          <p
                            v-if="(requestForm.status == 'To prepare' || editFormInOtherStatus) && !customerNRIC"
                            class="placeholder__text"
                          />
                          <p v-else>
                            {{ customerNRIC || '-' }}
                          </p>
                        </div>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4">
                      <b-form-group
                        label-cols="12"
                        label-cols-md="3"
                        label-cols-lg="2"
                        label="I,"
                        label-for="input-default"
                        class="align-items-center"
                      >
                        <div
                          v-if="currentKinNameType == 'input'"
                          class="empty-input__text"
                          :class="{ 'bg-white': (requestForm.status != 'To prepare' || kinName), 'edit-mode': editFormInOtherStatus }"
                          @click="handleClick('kinName', 'kinDetailsRef')"
                        >
                          <p
                            v-if="(requestForm.status == 'To prepare' || editFormInOtherStatus) && !kinName"
                            class="placeholder__text"
                          />
                          <p v-else>
                            {{ kinName || '-' }}
                          </p>
                        </div>
                        <div
                          v-else
                          :class="{ 'signed': kinNameImage }"
                          style="border-bottom: 1px solid #000"
                        >
                          <b-img
                            v-if="kinNameImage"
                            :src="kinNameImage"
                            class="w-100 signature-image"
                            alt="sign"
                          />
                        </div>
                      </b-form-group>
                    </b-col>
                    <b-col md="8">
                      <b-form-group
                        label-class="label-width-180"
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-lg="3"
                        label="Next of Kin (NRIC:)"
                        label-for="input-default"
                        class="align-items-center"
                      >
                        <div
                          class="empty-input__text"
                          :class="{ 'bg-white': (requestForm.status != 'To prepare' || kinNRIC), 'edit-mode': editFormInOtherStatus }"
                          @click="handleClick('kinNRIC', 'kinDetailsRef')"
                        >
                          <p
                            v-if="(requestForm.status == 'To prepare' || editFormInOtherStatus) && !kinNRIC"
                            class="placeholder__text"
                          />
                          <p v-else>
                            {{ kinNRIC || '-' }}
                          </p>
                        </div>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="5">
                      <b-form-group
                        label-class="label-width-320"
                        label-cols="12"
                        label-cols-md="5"
                        label-cols-lg="5"
                        label="do hereby acknowledge retrieval of*"
                        label-for="input-default"
                        class="align-items-center"
                      >
                        <div
                          class="empty-input__text"
                          :class="{ 'bg-white': (requestForm.status != 'To prepare' || numberOfUnit), 'edit-mode': editFormInOtherStatus }"
                          @click="handleClick('numberOfUnit', 'redemptionDetailsRef')"
                        >
                          <p
                            v-if="(requestForm.status == 'To prepare' || editFormInOtherStatus) && !numberOfUnit"
                            class="placeholder__text"
                          />
                          <p v-else>
                            {{ numberOfUnit || '-' }}
                          </p>
                        </div>
                      </b-form-group>
                    </b-col>
                    <b-col md="7">
                      <b-form-group
                        label-class="label-width-320"
                        label-cols="12"
                        label-cols-md="5"
                        label-cols-lg="5"
                        label="unit of the imported Urn, of the File No.*"
                        label-for="input-default"
                        class="align-items-center"
                      >
                        <div
                          class="empty-input__text"
                          :class="{ 'bg-white': (requestForm.status != 'To prepare' || fileNo), 'edit-mode': editFormInOtherStatus }"
                          @click="handleClick('fileNo', 'redemptionDetailsRef')"
                        >
                          <p
                            v-if="(requestForm.status == 'To prepare' || editFormInOtherStatus) && !fileNo"
                            class="placeholder__text"
                          />
                          <p v-else>
                            {{ fileNo || '-' }}
                          </p>
                        </div>
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <b-form-group
                        label-class="label-width-80"
                        label-cols="12"
                        label-cols-md="2"
                        label-cols-lg="2"
                        label="Urn File No."
                        label-for="input-default"
                        class="align-items-center"
                      >
                        <div
                          class="empty-input__text"
                          :class="{ 'bg-white': (requestForm.status != 'To prepare' || urnFileNo), 'edit-mode': editFormInOtherStatus }"
                          @click="handleClick('urnFileNo', 'redemptionDetailsRef')"
                        >
                          <p
                            v-if="(requestForm.status == 'To prepare' || editFormInOtherStatus) && !urnFileNo"
                            class="placeholder__text"
                          />
                          <p v-else>
                            {{ urnFileNo || '-' }}
                          </p>
                        </div>
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <b-form-group
                        label-class="label-width-80"
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-lg="4"
                        label="Related File Number"
                        label-for="input-default"
                        class="align-items-center"
                      >
                        <div
                          class="empty-input__text"
                          :class="{ 'bg-white': (requestForm.status != 'To prepare' || relatedFileNo), 'edit-mode': editFormInOtherStatus }"
                          @click="handleClick('relatedFileNo', 'redemptionDetailsRef')"
                        >
                          <p
                            v-if="(requestForm.status == 'To prepare' || editFormInOtherStatus) && !relatedFileNo"
                            class="placeholder__text"
                          />
                          <p v-else>
                            {{ relatedFileNo || '-' }}
                          </p>
                        </div>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <div class="d-form-warning-text-block">
                    <p class="d-form-warning-text">
                      as per below on:
                    </p>
                    <p class="d-form-warning-text">
                      本人乃新加玻富贵山庄福位购买者 / 购买者之委托人（本人身份证号，文件号码，购买证书编号如上述）现领取如数骨瓮（骨瓮类别与数量如下表纪录
                    </p>
                  </div>
                  <div class="mt-5">
                    <b-table-simple
                      bordered
                      responsive
                    >
                      <b-tbody>
                        <b-tr>
                          <b-td
                            colspan="5"
                            class="text-center"
                          >
                            <span>Urn Retrieval Record (Please note the accuracy in the relevant Urn and Quantity)</span>
                            <br>
                            <span>领取骨瓮记载 （请选填类别与数量</span>
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <td
                            :rowspan="splitQuantity ? 2 : 1"
                            width="40%"
                          >
                            Type of Urn
                          </td>
                          <td :rowspan="splitQuantity ? 2 : 1">
                            Urn Code
                          </td>
                          <td :rowspan="splitQuantity ? 2 : 1">
                            Item File No.
                          </td>
                          <td
                            :colspan="splitQuantity ? 2 : 1"
                            class="text-center"
                          >
                            Quantity
                          </td>
                        </b-tr>
                        <b-tr v-if="splitQuantity">
                          <td class="text-center">
                            NMG
                          </td>
                          <td class="text-center">
                            MPL
                          </td>
                        </b-tr>
                        <b-tr
                          v-for="(item, index) in inventoryItems"
                          :key="index"
                        >
                          <b-td>
                            <span>{{ item.name }}</span>
                          </b-td>
                          <b-td>
                            {{ item.sku }}
                          </b-td>
                          <b-td>
                            {{ item.fileNo }}
                          </b-td>
                          <b-td
                            class="text-center"
                            :class="{ 'd-form-table-td-blank-bg': requestForm.status == 'To prepare', 'value-filled': item.quantity[0] > 0, 'edit-mode': editFormInOtherStatus }"
                          >
                            {{ item.quantity[0] > 0 ? item.quantity[0] : '' }}
                          </b-td>
                          <b-td
                            v-if="splitQuantity"
                            class="text-center"
                            :class="{ 'd-form-table-td-blank-bg': requestForm.status == 'To prepare', 'value-filled': (item.quantity[1] != undefined && item.quantity[1] > 0), 'edit-mode': editFormInOtherStatus }"
                          >
                            {{ (item.quantity[1] != undefined && item.quantity[1] > 0) ? item.quantity[1] : '' }}
                          </b-td>
                        </b-tr>
                        <!-- <b-tr>
                          <b-td>
                            <b-form-checkbox
                              v-model="lgcwbs"
                              value="lgcwbs"
                              style="pointer-events: none;"
                              class="form-custom-input-checkbox"
                            />
                          </b-td>
                          <b-td>
                            <span>Light Green Crystal with Buddhist Sutra</span>
                            <br>
                            <span>心若彼岸 （浅青琉璃经文罐</span>
                          </b-td>
                          <b-td>
                            URN0-CRST-LTGN-1203
                          </b-td>
                          <b-td
                            class="text-center"
                            :class="{ 'd-form-table-td-blank-bg': requestForm.status == 'To prepare', 'value-filled': lgcwbsNmg > 0, 'edit-mode': editFormInOtherStatus }"
                          >
                            {{ lgcwbsNmg > 0 ? lgcwbsNmg : '' }}
                          </b-td>
                          <b-td
                            class="text-center"
                            :class="{ 'd-form-table-td-blank-bg': requestForm.status == 'To prepare', 'value-filled': lgcwbsMpl > 0, 'edit-mode': editFormInOtherStatus }"
                          >
                            {{ lgcwbsMpl > 0 ? lgcwbsMpl : '' }}
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-td>
                            <b-form-checkbox
                              v-model="lcwbs"
                              value="lcwbs"
                              style="pointer-events: none;"
                              class="form-custom-input-checkbox"
                            />
                          </b-td>
                          <b-td>
                            <span>Lavender Crystal with Buddhist Sutra</span>
                            <br>
                            <span>紫罗兰琉璃经文罐</span>
                          </b-td>
                          <b-td>
                            URN0-LAVENDER-CRST-LIULI
                          </b-td>
                          <b-td
                            class="text-center"
                            :class="{ 'd-form-table-td-blank-bg': requestForm.status == 'To prepare', 'value-filled': lcwbsNmg > 0, 'edit-mode': editFormInOtherStatus }"
                          >
                            {{ lcwbsNmg > 0 ? lcwbsNmg : '' }}
                          </b-td>
                          <b-td
                            class="text-center"
                            :class="{ 'd-form-table-td-blank-bg': requestForm.status == 'To prepare', 'value-filled': lcwbsMpl > 0, 'edit-mode': editFormInOtherStatus }"
                          >
                            {{ lcwbsMpl > 0 ? lcwbsMpl : '' }}
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-td>
                            <b-form-checkbox
                              v-model="pcll"
                              value="pcll"
                              style="pointer-events: none;"
                              class="form-custom-input-checkbox"
                            />
                          </b-td>
                          <b-td>
                            <span>Pink Crystal Liu Li</span>
                            <br>
                            <span>粉红晶琉璃罐</span>
                          </b-td>
                          <b-td>
                            URN0-PINK-CRST-LIULI
                          </b-td>
                          <b-td
                            class="text-center"
                            :class="{ 'd-form-table-td-blank-bg': requestForm.status == 'To prepare', 'value-filled': pcllNmg > 0, 'edit-mode': editFormInOtherStatus }"
                          >
                            {{ pcllNmg > 0 ? pcllNmg : '' }}
                          </b-td>
                          <b-td
                            class="text-center"
                            :class="{ 'd-form-table-td-blank-bg': requestForm.status == 'To prepare', 'value-filled': pcllMpl > 0, 'edit-mode': editFormInOtherStatus }"
                          >
                            {{ pcllMpl > 0 ? pcllMpl : '' }}
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-td>
                            <b-form-checkbox
                              v-model="byll"
                              value="byll"
                              style="pointer-events: none;"
                              class="form-custom-input-checkbox"
                            />
                          </b-td>
                          <b-td>
                            <span>Beeswax Yellow Liu Li</span>
                            <br>
                            <span>蜜蜡黄琉璃罐</span>
                          </b-td>
                          <b-td>
                            URN0-BEES-YELW-LIULI
                          </b-td>
                          <b-td
                            class="text-center"
                            :class="{ 'd-form-table-td-blank-bg': requestForm.status == 'To prepare', 'value-filled': byllNmg > 0, 'edit-mode': editFormInOtherStatus }"
                          >
                            {{ byllNmg > 0 ? byllNmg : '' }}
                          </b-td>
                          <b-td
                            class="text-center"
                            :class="{ 'd-form-table-td-blank-bg': requestForm.status == 'To prepare', 'value-filled': byllMpl > 0, 'edit-mode': editFormInOtherStatus }"
                          >
                            {{ byllMpl > 0 ? byllMpl : '' }}
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-td>
                            <b-form-checkbox
                              v-model="ro"
                              value="ro"
                              style="pointer-events: none;"
                              class="form-custom-input-checkbox"
                            />
                          </b-td>
                          <b-td>
                            <span>Red Onyx</span>
                            <br>
                            <span>写意人生（红玉罐</span>
                          </b-td>
                          <b-td>
                            URN0-ONYX-RED0-0212
                          </b-td>
                          <b-td
                            class="text-center"
                            :class="{ 'd-form-table-td-blank-bg': requestForm.status == 'To prepare', 'value-filled': roNmg > 0, 'edit-mode': editFormInOtherStatus }"
                          >
                            {{ roNmg > 0 ? roNmg : '' }}
                          </b-td>
                          <b-td
                            class="text-center"
                            :class="{ 'd-form-table-td-blank-bg': requestForm.status == 'To prepare', 'value-filled': roMpl > 0, 'edit-mode': editFormInOtherStatus }"
                          >
                            {{ roMpl > 0 ? roMpl : '' }}
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-td>
                            <b-form-checkbox
                              v-model="pj"
                              value="pj"
                              style="pointer-events: none;"
                              class="form-custom-input-checkbox"
                            />
                          </b-td>
                          <b-td>
                            <span>Poppy Jade</span>
                            <br>
                            <span>芙蓉西施玉（芙蓉玉罐</span>
                          </b-td>
                          <b-td>
                            URN0-JADE-POPY-1000
                          </b-td>
                          <b-td
                            class="text-center"
                            :class="{ 'd-form-table-td-blank-bg': requestForm.status == 'To prepare', 'value-filled': pjNmg > 0, 'edit-mode': editFormInOtherStatus }"
                          >
                            {{ pjNmg > 0 ? pjNmg : '' }}
                          </b-td>
                          <b-td
                            class="text-center"
                            :class="{ 'd-form-table-td-blank-bg': requestForm.status == 'To prepare', 'value-filled': pjMpl > 0, 'edit-mode': editFormInOtherStatus }"
                          >
                            {{ pjMpl > 0 ? pjMpl : '' }}
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-td>
                            <b-form-checkbox
                              v-model="rj"
                              value="rj"
                              style="pointer-events: none;"
                              class="form-custom-input-checkbox"
                            />
                          </b-td>
                          <b-td>
                            <span>Royalty Jade</span>
                            <br>
                            <span>皇家白玉</span>
                          </b-td>
                          <b-td>
                            URN0-RY-JADE_ORG
                          </b-td>
                          <b-td
                            class="text-center"
                            :class="{ 'd-form-table-td-blank-bg': requestForm.status == 'To prepare', 'value-filled': rjNmg > 0, 'edit-mode': editFormInOtherStatus }"
                          >
                            {{ rjNmg > 0 ? rjNmg : '' }}
                          </b-td>
                          <b-td
                            class="text-center"
                            :class="{ 'd-form-table-td-blank-bg': requestForm.status == 'To prepare', 'value-filled': rjMpl > 0, 'edit-mode': editFormInOtherStatus }"
                          >
                            {{ rjMpl > 0 ? rjMpl : '' }}
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-td>
                            <b-form-checkbox
                              v-model="others"
                              value="others"
                              style="pointer-events: none;"
                              class="form-custom-input-checkbox"
                            />
                          </b-td>
                          <b-td>
                            <span>Others</span>
                            <br>
                            <span>其他</span>
                          </b-td>
                          <b-td>
                            {{ othersName || '-' }}
                          </b-td>
                          <b-td
                            class="text-center"
                            :class="{ 'd-form-table-td-blank-bg': requestForm.status == 'To prepare', 'value-filled': othersNmg > 0, 'edit-mode': editFormInOtherStatus }"
                          >
                            {{ othersNmg > 0 ? othersNmg : '' }}
                          </b-td>
                          <b-td
                            class="text-center"
                            :class="{ 'd-form-table-td-blank-bg': requestForm.status == 'To prepare', 'value-filled': othersMpl > 0, 'edit-mode': editFormInOtherStatus }"
                          >
                            {{ othersMpl > 0 ? othersMpl : '' }}
                          </b-td>
                        </b-tr> -->
                      </b-tbody>
                    </b-table-simple>
                  </div>
                  <b-row class="mt-5">
                    <b-col md="6">
                      <p class="d-form-signature-title">Purchaser / Authorized Representative Signatory
                        <br>
                        <span>购买者/受委托领瓮人签名</span>
                      </p>
                      <div
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        v-b-modal.purchaser-sign-modal
                        class="form-signature-box"
                        :class="{ 'signed': isPurchaserSign, 'edit-mode': editFormInOtherStatus }"
                        :disabled="(requestForm.status == 'Signed and Sent' && !editFormInOtherStatus) || ['To prepare', 'Ready to sign', 'Not required'].includes(requestForm.status)"
                      >
                        <div class="form-signature-content">
                          <span
                            v-if="!isPurchaserSign"
                            class="form-signature-text"
                          >
                            Sign here
                          </span>
                          <b-img
                            v-else
                            :src="purchaserSign"
                            alt="authorized-sign"
                          />
                        </div>
                      </div>
                      <div class="signature-date-block">
                        <p>Name 姓名: {{ customerName }}</p>
                        <p v-if="purchaserSignDate">
                          Date 日期: {{ dateFormatWithTime(purchaserSignDate) }}
                        </p>
                        <p v-else>
                          Date 日期:
                        </p>
                      </div>
                    </b-col>
                  </b-row>
                  <div class="d-form-border mt-4">
                    <h5 class="d-form-office-use-title">
                      For office use 公务用栏
                    </h5>
                    <b-row>
                      <b-col
                        md="6"
                        class="pr-0 padding-right-auto"
                      >
                        <div class="padding-20">
                          <p class="d-form-signature-title">
                            Verified by 确认人员:</p>
                          <div
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            v-b-modal.verified-sign-modal
                            class="form-signature-box"
                            :class="{ 'signed': verifiedSign, 'edit-mode': editFormInOtherStatus }"
                            :disabled="(requestForm.status == 'Signed and Sent' && !editFormInOtherStatus) || ['To prepare', 'Ready to sign', 'Not required'].includes(requestForm.status)"
                          >
                            <div class="form-signature-content">
                              <span
                                v-if="!verifiedSign"
                                class="form-signature-text"
                              >
                                Sign here
                              </span>
                              <b-img
                                v-else
                                :src="verifiedSignSrc"
                                alt="authorized-sign"
                              />
                            </div>
                          </div>
                          <div class="signature-date-block">
                            <p>Name 姓名: {{ verifiedSignName }}</p>
                            <p v-if="verifiedSignDate">
                              Date 日期: {{ dateFormatWithTime(verifiedSignDate) }}
                            </p>
                            <p v-else>
                              Date 日期:
                            </p>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>

        <div
          v-if="requestForm.status == 'To prepare'"
          class="d-form_action-btn_group wrap-border save-nav"
        >
          <p
            v-if="isMobile()"
            class="margin-left-20 mt-50 mb-50 d-form_action-title"
          >
            <span>Redemption of imported urn</span>
          </p>
          <b-nav
            :class="{'d-form_action-btn_tablet': isMobile()}"
            class="padding-left-right-20"
          >
            <li
              v-if="!isMobile()"
              class="nav-item"
            >
              <span>Redemption of imported urn</span>
            </li>
            <li
              class="nav-item"
              :class="{'d-form_action-btn__mob-li': isMobile(), 'ml-auto margin-right-5': !isMobile()}"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="button"
                variant="outline-primary"
                @click="submitSaveForm('saveOnly')"
              >
                Save changes
              </b-button>
            </li>
            <li
              class="nav-item d-form_action-second_btn"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="button"
                variant="primary"
                @click="makeFormNotRequired"
              >
                <feather-icon
                  icon="XCircleIcon"
                  class="mr-50"
                />
                <span class="align-middle">Mark as Not Required</span>
              </b-button>
            </li>
            <li
              class="nav-item d-form_action-third_btn"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="button"
                variant="success"
                @click="submitSaveForm('readyToSign')"
              >
                <feather-icon
                  icon="FeatherIcon"
                  class="mr-50"
                />
                <span class="align-middle">Mark as Ready to Sign</span>
              </b-button>
            </li>
          </b-nav>
        </div>

        <div
          v-if="editFormInOtherStatus"
          class="d-form_action-btn_group wrap-border save-nav"
        >
          <p
            v-if="isMobile()"
            class="margin-left-20 mt-50 mb-50 d-form_action-title"
          >
            <span>Editing Redemption of Imported Urn</span>
          </p>
          <b-nav
            class="padding-left-right-20"
            :class="{'d-form_action-btn_tablet': isMobile()}"
          >
            <li
              v-if="!isMobile()"
              class="nav-item"
            >
              <span>Editing Redemption of Imported Urn</span>
            </li>
            <li
              :class="{'ml-auto margin-right-5': !isMobile(), 'mob__cancel-btn': isMobile()}"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="button"
                variant="outline-primary"
                class="action-cancel_btn"
                @click="editFormInOtherStatus = false; makeFormValues()"
              >
                Cancel Editing
              </b-button>
            </li>
            <li
              class="nav-item"
              :class="{'d-form_action-editing__btn': isMobile()}"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="button"
                variant="success"
                class="action-done_btn"
                @click="submitSaveFormConfirmation()"
              >
                <feather-icon
                  icon="CheckIcon"
                  class="mr-50"
                />
                <span class="align-middle">Done</span>
              </b-button>
            </li>
          </b-nav>
        </div>
      </b-form>
    </validation-observer>
    <!-- authorized signature modal -->
    <b-modal
      id="purchaser-sign-modal"
      ref="purchaser-sign-modal"
      modal-class="status-update-modal sign-modal-adjust"
      centered
      no-stacking
      no-close-on-backdrop
      header-class="front-modal"
      title="Authorized Signature"
      @ok="closePurchaserSignModal"
      @cancel="closePurchaserSignModal"
    >
      <template #modal-title>
        <span>
          Signature
        </span>
        <br>
        <span class="weight-400 fs-14">Purchaser / Authorized Representative Signatory & Date</span>
      </template>
      <div class="">
        <VueSignaturePad
          ref="signaturePad"
          class="border rounded"
          width="100%"
          height="260px"
          :options="options"
        />
      </div>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="flat-primary"
          class="mr-auto ml-0 pl-0"
          @click="clearPurchaserSign()"
        >
          Clear
        </b-button>
        <b-button
          variant="outline-primary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          @click="savePurchaserSign()"
        >
          <span class="align-middle">Save</span>
        </b-button>
      </template>
    </b-modal>
    <!-- ./ authorized signature modal -->
    <!-- verified by signature modal -->
    <b-modal
      id="verified-sign-modal"
      ref="verified-sign-modal"
      modal-class="status-update-modal sign-modal-adjust"
      centered
      no-stacking
      no-close-on-backdrop
      header-class="front-modal"
      title="Verified By"
      @ok="closeVerifiedSignModal"
      @cancel="closeVerifiedSignModal"
    >
      <template #modal-title>
        <span>
          Signature
        </span>
        <br>
        <span class="weight-400 fs-14">Verified By</span>
      </template>
      <div class="">
        <VueSignaturePad
          ref="signaturePad"
          class="border rounded"
          width="100%"
          height="260px"
          :options="options"
        />
      </div>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="flat-primary"
          class="mr-auto ml-0 pl-0"
          @click="clearVerifiedSign()"
        >
          Clear
        </b-button>
        <b-button
          variant="outline-primary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          @click="saveVerifiedSign()"
        >
          <span class="align-middle">Save</span>
        </b-button>
      </template>
    </b-modal>
    <!-- ./ verified by signature modal -->
    <!-- customer name modal -->
    <b-modal
      id="customer-name-modal"
      ref="customer-name-modal"
      modal-class="status-update-modal sign-modal-adjust"
      centered
      no-stacking
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      header-class="front-modal"
      title="Handwriting 手写"
      @cancel="closeCustomerNameModal"
    >
      <div class="">
        <VueSignaturePad
          ref="customerSignaturePad"
          class="border rounded"
          width="100%"
          height="260px"
          :options="customerNameOptions"
        />
      </div>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="flat-primary"
          class="mr-auto ml-0 pl-0"
          @click="clearCustomerName()"
        >
          Clear
        </b-button>
        <b-button
          variant="outline-primary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          @click="saveCustomerName()"
        >
          <span class="align-middle">Save</span>
        </b-button>
      </template>
    </b-modal>
    <!-- customer name -->
    <!-- kin name modal -->
    <b-modal
      id="kin-name-modal"
      ref="kin-name-modal"
      modal-class="status-update-modal sign-modal-adjust"
      centered
      no-stacking
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      header-class="front-modal"
      title="Handwriting 手写"
      @cancel="closeKinNameModal"
    >
      <div class="">
        <VueSignaturePad
          ref="kinSignaturePad"
          class="border rounded"
          width="100%"
          height="260px"
          :options="kinNameOptions"
        />
      </div>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="flat-primary"
          class="mr-auto ml-0 pl-0"
          @click="clearKinName()"
        >
          Clear
        </b-button>
        <b-button
          variant="outline-primary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          @click="saveKinName()"
        >
          <span class="align-middle">Save</span>
        </b-button>
      </template>
    </b-modal>
    <!-- kin name -->

    <!-- submit signed form -->
    <b-modal
      id="submit-form-modal"
      ref="submit-form-modal"
      modal-class="status-update-modal sign-modal-adjust sign-form_modal-adjust"
      centered
      no-stacking
      no-close-on-backdrop
      header-class="front-modal"
      title="Submit this signed form?"
      @ok="submitSignedForm"
      @cancel="submitSignedForm(null, false)"
    >
      <div class="">
        <div>
          If the information in <strong>{{ requestForm.formID.name }} Form</strong> is accurate, submitting this form will generate a PDF copy to be sent out to customer.
        </div>
        <div class="mt-1 mb-50">
          Please confirm the PDF will be send via:
        </div>
        <b-tabs
          pills
          class="d-form-tab submit-d-form booking__content"
        >
          <b-tab
            :active="tabActive == 'email'"
            class="tab-content-wrapper"
            @click="tabActive = 'email'"
          >
            <template #title>
              <span class="">Email Only</span>
            </template>
            <b-form-group
              label="Email Address"
              label-for="customer-email"
              class="mb-0"
            >
              <validation-provider
                #default="{ errors }"
                name="Email Address"
                vid="customer-email"
                rules="required"
              >
                <b-form-input
                  id="customer-email"
                  v-model="customerEmailVal"
                  placeholder="jlam@gmail.com"
                  class="mb-0"
                  :state="(errors.length > 0) ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group
              label="Message to customer (optional)"
              label-for="customer-message"
              class="mt-75"
            >
              <validation-provider
                name="customer-message"
                vid="customer-message"
                rules=""
              >
                <quill-editor
                  v-model="customerMessageValEmail"
                  :options="editorOptionEmail"
                >
                  <div
                    id="customer-email-message"
                    slot="toolbar"
                  >
                    <!-- Add a bold button -->
                    <button class="ql-bold">
                      Bold
                    </button>
                    <button class="ql-italic">
                      Italic
                    </button>
                    <button class="ql-underline">
                      Underline
                    </button>
                    <select class="ql-size">
                      <option value="small" />
                      <!-- Note a missing, thus falsy value, is used to reset to default -->
                      <option selected />
                      <option value="large" />
                      <option value="huge" />
                    </select>

                    <select class="ql-align">
                      <option selected="selected" />
                      <option value="center" />
                      <option value="right" />
                      <option value="justify" />
                    </select>
                  </div>
                </quill-editor>
              </validation-provider>
            </b-form-group>
          </b-tab>
          <b-tab
            :active="tabActive == 'phone'"
            class="tab-content-wrapper"
            @click="tabActive = 'phone'"
          >
            <template #title>
              <span class="">SMS Only</span>
            </template>
            <b-form-group
              label="Mobile Number"
              label-for="customer-mobile"
              class="mb-0"
            >
              <validation-provider
                #default="{ errors }"
                name="Mobile Number"
                vid="customer-mobile"
                rules="required"
              >
                <b-form-input
                  id="customer-mobile"
                  v-model="customerMobileVal"
                  placeholder="+65 98784248"
                  class="mb-0"
                  :state="(errors.length > 0) ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group
              label="Message to customer (optional)"
              label-for="customer-message"
              class="mt-75"
            >
              <validation-provider
                name="customer-message"
                vid="customer-message"
                rules=""
              >
                <b-form-textarea
                  v-model="customerMessageValPhone"
                  placeholder="Enter"
                  rows="3"
                  name="customerMessageValPhone"
                />
              </validation-provider>
            </b-form-group>
          </b-tab>
        </b-tabs>
        <div
          class="text-center"
          style="margin-top: 17px; margin-bottom: 17px; font-size: 12px; color: rgba(0, 0, 0, 0.50);"
        >
          <small>
            Note: This is a password protected document.
          </small>
          <br>
          <small>
            The password format is customer’s mobile number (XXXXXXXX).
          </small>
        </div>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="outline-primary"
          class="mr-auto ml-0"
          @click="cancel()"
        >
          <feather-icon
            icon="SaveIcon"
            size="16"
            class="mr-50"
          />
          <span class="align-middle">Skip sending and save</span>
        </b-button>
        <b-button
          variant="success"
          class="custom-icon mr-0"
          :disabled="(tabActive == 'email' && !customerEmailVal) || (tabActive == 'phone' && !customerMobileVal)"
          @click="ok()"
        >
          <feather-icon
            icon="ArrowRightIcon"
            size="16"
            class="mr-50"
          />
          <span class="align-middle">Yes, Proceed</span>
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="resend-form-modal"
      ref="resend-form-modal"
      modal-class="status-update-modal sign-modal-adjust sign-form_modal-adjust"
      centered
      no-stacking
      no-close-on-backdrop
      header-class="front-modal"
      title="Resend this form?"
      @ok="resendSignedForm"
      @cancel="closeResendFormModal"
    >
      <div class="">
        <div>
          If the information in <strong>{{ requestForm.formID.name }} Form</strong> is accurate, submitting this form will generate a PDF copy to be sent out to customer.
        </div>
        <div class="mt-1 mb-50">
          Please confirm the PDF will be send via:
        </div>
        <b-tabs
          pills
          class="d-form-tab submit-d-form booking__content"
        >
          <b-tab
            :active="tabActive == 'email'"
            class="tab-content-wrapper"
            @click="tabActive = 'email'"
          >
            <template #title>
              <span class="">Email Only</span>
            </template>
            <b-form-group
              label="Email Address"
              label-for="customer-email"
              class="mb-0"
            >
              <validation-provider
                #default="{ errors }"
                name="Email Address"
                vid="customer-email"
                rules="required"
              >
                <b-form-input
                  id="customer-email"
                  v-model="customerEmailVal"
                  placeholder="jlam@gmail.com"
                  class="mb-0"
                  :state="(errors.length > 0) ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group
              label="Message to customer (optional)"
              label-for="customer-message"
              class="mt-75"
            >
              <validation-provider
                name="customer-message"
                vid="customer-message"
                rules=""
              >
                <quill-editor
                  v-model="customerMessageValEmail"
                  :options="editorOptionEmail"
                >
                  <div
                    id="customer-email-message"
                    slot="toolbar"
                  >
                    <!-- Add a bold button -->
                    <button class="ql-bold">
                      Bold
                    </button>
                    <button class="ql-italic">
                      Italic
                    </button>
                    <button class="ql-underline">
                      Underline
                    </button>
                    <select class="ql-size">
                      <option value="small" />
                      <!-- Note a missing, thus falsy value, is used to reset to default -->
                      <option selected />
                      <option value="large" />
                      <option value="huge" />
                    </select>

                    <select class="ql-align">
                      <option selected="selected" />
                      <option value="center" />
                      <option value="right" />
                      <option value="justify" />
                    </select>
                  </div>
                </quill-editor>
              </validation-provider>
            </b-form-group>
          </b-tab>
          <b-tab
            :active="tabActive == 'phone'"
            class="tab-content-wrapper"
            @click="tabActive = 'phone'"
          >
            <template #title>
              <span class="">SMS Only</span>
            </template>
            <b-form-group
              label="Mobile Number"
              label-for="customer-mobile"
              class="mb-0"
            >
              <validation-provider
                #default="{ errors }"
                name="Mobile Number"
                vid="customer-mobile"
                rules="required"
              >
                <b-form-input
                  id="customer-mobile"
                  v-model="customerMobileVal"
                  placeholder="+65 98784248"
                  class="mb-0"
                  :state="(errors.length > 0) ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group
              label="Message to customer (optional)"
              label-for="customer-message"
              class="mt-75"
            >
              <validation-provider
                name="customer-message"
                vid="customer-message"
                rules=""
              >
                <b-form-textarea
                  v-model="customerMessageValPhone"
                  placeholder="Enter"
                  rows="3"
                  name="customerMessageValPhone"
                />
              </validation-provider>
            </b-form-group>
          </b-tab>
        </b-tabs>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="flat-primary"
          @click="cancel()"
        >
          No, back to Form
        </b-button>
        <b-button
          variant="success"
          class="custom-icon"
          :disabled="(tabActive == 'email' && !customerEmailVal) || (tabActive == 'phone' && !customerMobileVal)"
          @click="ok()"
        >
          <feather-icon
            icon="ArrowRightIcon"
            size="16"
            class="mr-50"
          />
          <span class="align-middle">Yes, Proceed</span>
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="edit-form-modal"
      ref="edit-form-modal"
      modal-class="status-update-modal sign-modal-adjust sign-form_modal-adjust"
      centered
      no-stacking
      no-close-on-backdrop
      header-class="front-modal"
      title="Submit this edited form?"
      @ok="submitSaveForm('edited', true)"
      @cancel="submitSaveForm('edited', true, false)"
    >
      <div class="">
        <div>
          If the information in <strong>{{ requestForm.formID.name }} Form</strong> is accurate, submitting this form will generate a PDF copy to be sent out to customer.
        </div>
        <div class="mt-1 mb-50">
          Please confirm the PDF will be send via:
        </div>
        <b-tabs
          pills
          class="d-form-tab submit-d-form booking__content"
        >
          <b-tab
            :active="tabActive == 'email'"
            class="tab-content-wrapper"
            @click="tabActive = 'email'"
          >
            <template #title>
              <span class="">Email Only</span>
            </template>
            <b-form-group
              label="Email Address"
              label-for="customer-email"
              class="mb-0"
            >
              <validation-provider
                #default="{ errors }"
                name="Email Address"
                vid="customer-email"
                rules="required"
              >
                <b-form-input
                  id="customer-email"
                  v-model="customerEmailVal"
                  placeholder="jlam@gmail.com"
                  class="mb-0"
                  :state="(errors.length > 0) ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group
              label="Message to customer (optional)"
              label-for="customer-message"
              class="mt-75"
            >
              <validation-provider
                name="customer-message"
                vid="customer-message"
                rules=""
              >
                <quill-editor
                  v-model="customerMessageValEmail"
                  :options="editorOptionEmail"
                >
                  <div
                    id="customer-email-message"
                    slot="toolbar"
                  >
                    <!-- Add a bold button -->
                    <button class="ql-bold">
                      Bold
                    </button>
                    <button class="ql-italic">
                      Italic
                    </button>
                    <button class="ql-underline">
                      Underline
                    </button>
                    <select class="ql-size">
                      <option value="small" />
                      <!-- Note a missing, thus falsy value, is used to reset to default -->
                      <option selected />
                      <option value="large" />
                      <option value="huge" />
                    </select>

                    <select class="ql-align">
                      <option selected="selected" />
                      <option value="center" />
                      <option value="right" />
                      <option value="justify" />
                    </select>
                  </div>
                </quill-editor>
              </validation-provider>
            </b-form-group>
          </b-tab>
          <b-tab
            :active="tabActive == 'phone'"
            class="tab-content-wrapper"
            @click="tabActive = 'phone'"
          >
            <template #title>
              <span class="">SMS Only</span>
            </template>
            <b-form-group
              label="Mobile Number"
              label-for="customer-mobile"
              class="mb-0"
            >
              <validation-provider
                #default="{ errors }"
                name="Mobile Number"
                vid="customer-mobile"
                rules="required"
              >
                <b-form-input
                  id="customer-mobile"
                  v-model="customerMobileVal"
                  placeholder="+65 98784248"
                  class="mb-0"
                  :state="(errors.length > 0) ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group
              label="Message to customer (optional)"
              label-for="customer-message"
              class="mt-75"
            >
              <validation-provider
                name="customer-message"
                vid="customer-message"
                rules=""
              >
                <b-form-textarea
                  v-model="customerMessageValPhone"
                  placeholder="Enter"
                  rows="3"
                  name="customerMessageValPhone"
                />
              </validation-provider>
            </b-form-group>
          </b-tab>
        </b-tabs>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="outline-primary"
          class="mr-auto ml-0"
          @click="cancel()"
        >
          <feather-icon
            icon="SaveIcon"
            size="16"
            class="mr-50"
          />
          <span class="align-middle">Skip sending and save</span>
        </b-button>
        <b-button
          variant="success"
          class="custom-icon mr-0"
          :disabled="(tabActive == 'email' && !customerEmailVal) || (tabActive == 'phone' && !customerMobileVal)"
          @click="ok()"
        >
          <feather-icon
            icon="ArrowRightIcon"
            size="16"
            class="mr-50"
          />
          <span class="align-middle">Yes, Proceed</span>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BCardText, BRow, BCol, BFormGroup, BFormInput, BImg, BButton, BNav, BForm, BTab, BTabs,
  BTableSimple, BTbody, BTr, BTd, BFormTextarea, BAlert,
} from 'bootstrap-vue'
import store from '@/store/index'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
// eslint-disable-next-line
      import 'quill/dist/quill.core.css'
// eslint-disable-next-line
      import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
      import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import ToastificationContentCustom from '../../ToastificationContentCustom.vue'

export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BImg,
    BButton,
    BNav,
    BForm,
    BTab,
    BTabs,
    // BFormSpinbutton,
    // BFormCheckbox,
    BTableSimple,
    BTbody,
    BTr,
    BTd,
    BFormTextarea,
    BAlert,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContentCustom,
    quillEditor,
    ValidationProvider,
    ValidationObserver,
    AppCollapse,
    AppCollapseItem,
    AppTimeline,
    AppTimelineItem,
  },
  directives: {
    Ripple,
  },
  props: {
    digitalForm: {
      type: Object,
      required: true,
    },
    requestForm: {
      type: Object,
      required: true,
    },
    serviceRequest: {
      type: Object,
      required: true,
    },
    serviceRequestTasks: {
      type: Array,
      default: () => [],
    },
    topSpacing: {
      type: Number,
      default: 0,
    },
    taskId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      user: store.state.auth.userData,
      isPurchaserSign: false,
      purchaserSign: '',
      purchaserSignDate: '',
      verifiedSign: false,
      verifiedSignSrc: '',
      verifiedSignDate: '',
      verifiedSignName: '',
      customerNameImageError: false,
      kinNameImageError: false,
      urnCollapse: false,
      purchaserCollapse: false,
      kinCollapse: false,
      redemptionCollapse: true,
      editFormInOtherStatus: false,
      hasIR: false,
      inventoryItems: [],
      splitQuantity: false,
      tabActive: 'email',
      options: {
        penColor: '#000000',
        onBegin: () => { this.$refs.signaturePad.resizeCanvas() },
      },
      customerNameOptions: {
        penColor: '#000000',
        onBegin: () => { this.$refs.customerSignaturePad.resizeCanvas() },
      },
      kinNameOptions: {
        penColor: '#000000',
        onBegin: () => { this.$refs.kinSignaturePad.resizeCanvas() },
      },
      currentCustomerNameType: 'input',
      customerName: '',
      customerNameImage: '',
      customerNRIC: '',
      currentKinNameType: 'input',
      kinName: '',
      kinNameImage: '',
      kinNRIC: '',
      fileNo: '',
      urnFileNo: '',
      relatedFileNo: '',
      nicheLot: '',
      numberOfUnit: '',
      dgcwbs: '',
      dgcwbsMpl: 0,
      dgcwbsNmg: 0,
      lgcwbs: '',
      lgcwbsMpl: 0,
      lgcwbsNmg: 0,
      lcwbs: '',
      lcwbsMpl: 0,
      lcwbsNmg: 0,
      pcll: '',
      pcllMpl: 0,
      pcllNmg: 0,
      byll: '',
      byllMpl: 0,
      byllNmg: 0,
      ro: '',
      roMpl: 0,
      roNmg: 0,
      pj: '',
      pjMpl: 0,
      pjNmg: 0,
      rj: '',
      rjMpl: 0,
      rjNmg: 0,
      others: '',
      othersName: '',
      othersMpl: 0,
      othersNmg: 0,
      customerEmailVal: '',
      customerMobileVal: '',
      customerMessageValEmail: '',
      customerMessageValPhone: '',
      scrollSection: '',
      existingVerifiedSignSrcObject: {},
      existingPurchaserSignObject: {},
      editorOptionPhone: {
        modules: {
          toolbar: '#customer-sms-message',
        },
        placeholder: 'Type your message here',
      },
      editorOptionEmail: {
        modules: {
          toolbar: '#customer-email-message',
        },
        placeholder: 'Type your message here',
      },
      required,
    }
  },
  created() {
    this.makeFormValues()
    this.customerMobileVal = this.requestForm.customerContact
    this.customerEmailVal = this.requestForm.customerEmail
  },
  methods: {
    makeFormValues() {
      this.fileNo = this.serviceRequest.fileNo
      const customerNameObject = this.serviceRequest.formValues.find(o => o.key === 'customerName')
      if (customerNameObject) {
        if (customerNameObject.value.startsWith('data:image/')) {
          this.customerNameImage = customerNameObject.value
          this.currentCustomerNameType = 'canvas'
        } else {
          this.currentCustomerNameType = 'input'
          this.customerName = customerNameObject.value
        }
      }
      this.customerNRIC = this.serviceRequest.formValues.find(o => o.key === 'customerNRIC')?.value
      const kinNameObject = this.serviceRequest.formValues.find(o => o.key === 'kinName')
      if (kinNameObject) {
        if (kinNameObject.value.startsWith('data:image/')) {
          this.kinNameImage = kinNameObject.value
          this.currentKinNameType = 'canvas'
        } else {
          this.currentKinNameType = 'input'
          this.kinName = kinNameObject.value
        }
      }
      this.kinNRIC = this.serviceRequest.formValues.find(o => o.key === 'kinNRIC')?.value
      if (this.requestForm.values.length) {
        const nicheLotObject = this.requestForm.values.find(o => o.key === 'nicheLot')
        if (nicheLotObject) {
          this.nicheLot = nicheLotObject.value
        }
        const urnFileNoObject = this.requestForm.values.find(o => o.key === 'urnFileNo')
        if (urnFileNoObject) {
          this.urnFileNo = urnFileNoObject.value
        }
        const relatedFileNoObject = this.requestForm.values.find(o => o.key === 'relatedFileNo')
        if (relatedFileNoObject) {
          this.relatedFileNo = relatedFileNoObject.value
        }
        const numberOfUnitObject = this.requestForm.values.find(o => o.key === 'numberOfUnit')
        if (numberOfUnitObject) {
          this.numberOfUnit = numberOfUnitObject.value
        }
        // const dgcwbsObject = this.requestForm.values.find(o => o.key === 'dgcwbs')
        // if (dgcwbsObject) {
        //   this.dgcwbs = dgcwbsObject.value
        // }
        // const dgcwbsNmgObject = this.requestForm.values.find(o => o.key === 'dgcwbsNmg')
        // if (dgcwbsNmgObject) {
        //   this.dgcwbsNmg = dgcwbsNmgObject.value
        // }
        // const dgcwbsMplObject = this.requestForm.values.find(o => o.key === 'dgcwbsMpl')
        // if (dgcwbsMplObject) {
        //   this.dgcwbsMpl = dgcwbsMplObject.value
        // }
        // const lgcwbsObject = this.requestForm.values.find(o => o.key === 'lgcwbs')
        // if (lgcwbsObject) {
        //   this.lgcwbs = lgcwbsObject.value
        // }
        // const lgcwbsNmgObject = this.requestForm.values.find(o => o.key === 'lgcwbsNmg')
        // if (lgcwbsNmgObject) {
        //   this.lgcwbsNmg = lgcwbsNmgObject.value
        // }
        // const lgcwbsMplObject = this.requestForm.values.find(o => o.key === 'lgcwbsMpl')
        // if (lgcwbsMplObject) {
        //   this.lgcwbsMpl = lgcwbsMplObject.value
        // }
        // const lcwbsObject = this.requestForm.values.find(o => o.key === 'lcwbs')
        // if (lcwbsObject) {
        //   this.lcwbs = lcwbsObject.value
        // }
        // const lcwbsNmgObject = this.requestForm.values.find(o => o.key === 'lcwbsNmg')
        // if (lcwbsNmgObject) {
        //   this.lcwbsNmg = lcwbsNmgObject.value
        // }
        // const lcwbsMplObject = this.requestForm.values.find(o => o.key === 'lcwbsMpl')
        // if (lcwbsMplObject) {
        //   this.lcwbsMpl = lcwbsMplObject.value
        // }
        // const pcllObject = this.requestForm.values.find(o => o.key === 'pcll')
        // if (pcllObject) {
        //   this.pcll = pcllObject.value
        // }
        // const pcllNmgObject = this.requestForm.values.find(o => o.key === 'pcllNmg')
        // if (pcllNmgObject) {
        //   this.pcllNmg = pcllNmgObject.value
        // }
        // const pcllMplObject = this.requestForm.values.find(o => o.key === 'pcllMpl')
        // if (pcllMplObject) {
        //   this.pcllMpl = pcllMplObject.value
        // }
        // const byllObject = this.requestForm.values.find(o => o.key === 'byll')
        // if (byllObject) {
        //   this.byll = byllObject.value
        // }
        // const byllNmgObject = this.requestForm.values.find(o => o.key === 'byllNmg')
        // if (byllNmgObject) {
        //   this.byllNmg = byllNmgObject.value
        // }
        // const byllMplObject = this.requestForm.values.find(o => o.key === 'byllMpl')
        // if (byllMplObject) {
        //   this.byllMpl = byllMplObject.value
        // }
        // const roObject = this.requestForm.values.find(o => o.key === 'ro')
        // if (roObject) {
        //   this.ro = roObject.value
        // }
        // const roNmgObject = this.requestForm.values.find(o => o.key === 'roNmg')
        // if (roNmgObject) {
        //   this.roNmg = roNmgObject.value
        // }
        // const roMplObject = this.requestForm.values.find(o => o.key === 'roMpl')
        // if (roMplObject) {
        //   this.roMpl = roMplObject.value
        // }
        // const pjObject = this.requestForm.values.find(o => o.key === 'pj')
        // if (pjObject) {
        //   this.pj = pjObject.value
        // }
        // const pjNmgObject = this.requestForm.values.find(o => o.key === 'pjNmg')
        // if (pjNmgObject) {
        //   this.pjNmg = pjNmgObject.value
        // }
        // const pjMplObject = this.requestForm.values.find(o => o.key === 'pjMpl')
        // if (pjMplObject) {
        //   this.pjMpl = pjMplObject.value
        // }
        // const rjObject = this.requestForm.values.find(o => o.key === 'rj')
        // if (rjObject) {
        //   this.rj = rjObject.value
        // }
        // const rjNmgObject = this.requestForm.values.find(o => o.key === 'rjNmg')
        // if (rjNmgObject) {
        //   this.rjNmg = rjNmgObject.value
        // }
        // const rjMplObject = this.requestForm.values.find(o => o.key === 'rjMpl')
        // if (rjMplObject) {
        //   this.rjMpl = rjMplObject.value
        // }
        // const othersObject = this.requestForm.values.find(o => o.key === 'others')
        // if (othersObject) {
        //   this.others = othersObject.value
        // }
        // const othersNameObject = this.requestForm.values.find(o => o.key === 'othersName')
        // if (othersNameObject) {
        //   this.othersName = othersNameObject.value
        // }
        // const othersNmgObject = this.requestForm.values.find(o => o.key === 'othersNmg')
        // if (othersNmgObject) {
        //   this.othersNmg = othersNmgObject.value
        // }
        // const othersMplObject = this.requestForm.values.find(o => o.key === 'othersMpl')
        // if (othersMplObject) {
        //   this.othersMpl = othersMplObject.value
        // }
        const purchaserSignObject = this.requestForm.values.find(o => o.key === 'purchaserSign')
        if (purchaserSignObject && purchaserSignObject.value) {
          this.existingPurchaserSignObject = purchaserSignObject
          this.purchaserSign = purchaserSignObject.value
          this.isPurchaserSign = true
          this.purchaserSignDate = purchaserSignObject.date
        }
        const verifiedSignSrcObject = this.requestForm.values.find(o => o.key === 'verifiedSignSrc')
        if (verifiedSignSrcObject && verifiedSignSrcObject.value) {
          this.existingVerifiedSignSrcObject = verifiedSignSrcObject
          this.verifiedSignSrc = verifiedSignSrcObject.value
          this.verifiedSign = true
          this.verifiedSignDate = verifiedSignSrcObject.date
          this.verifiedSignName = verifiedSignSrcObject.name
        }
      }

      if (this.requestForm.status === 'To prepare') {
        this.getInventoryItems()
      } else {
        const inventoryItemsObject = this.requestForm.values.find(o => o.key === 'inventoryItems')
        if (inventoryItemsObject) {
          this.inventoryItems = inventoryItemsObject.value
        }

        const splitQuantityObj = this.requestForm.values.find(o => o.key === 'splitQuantity')
        if (splitQuantityObj) {
          this.splitQuantity = splitQuantityObj.value
        }
        this.hasIR = true
      }
    },
    getInventoryItems() {
      const irs = []
      this.serviceRequestTasks.forEach((task, key) => {
        task.taskBlocks.forEach(taskBlock => {
          if (taskBlock.block.name === 'Inventory Request' || taskBlock.block.name === 'Inventory Request From Entitlement') {
            const formField = taskBlock.fieldValues.find(o => o.key === 'Forms')
            if (formField && formField.value && formField.value === this.requestForm.formID._id) {
              if (taskBlock.inputValues && taskBlock.inputValues.length) {
                irs.push(...taskBlock.inputValues)
              }

              if (taskBlock.block.name === 'Inventory Request') {
                // eslint-disable-next-line eqeqeq
                if (taskBlock.fieldValues[3] && taskBlock.fieldValues[3].value == 2) {
                  this.splitQuantity = true
                }
              } else {
                // eslint-disable-next-line eqeqeq, no-lonely-if
                if (taskBlock.fieldValues[4] && taskBlock.fieldValues[4].value == 2) {
                  this.splitQuantity = true
                }
              }

              if (!this.scrollSection) {
                this.scrollSection = `#task-${key + 1}`
              }
            }
          }
        })
      })

      if (irs.length) {
        const formData = new FormData()
        formData.append('ir', JSON.stringify(irs))
        this.$http.post('inventory/inventory-request/respond-with-ir', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
          .then(response => {
            const { inventoryRequestTns } = response.data
            const itemsArray = []

            inventoryRequestTns.forEach(stockItem => {
              const obj = {
                itemID: stockItem.item._id,
                name: stockItem.item.name,
                sku: stockItem.item.sku,
                fileNo: stockItem.fileNo,
                quantity: stockItem.quantity,
              }

              itemsArray.push(obj)
            })
            this.inventoryItems = itemsArray
            this.hasIR = true
          })
          .catch(error => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
      }
    },
    clearQuantity(model) {
      const val = this[model]
      if (!val) {
        const nmg = `${model}Nmg`
        const mpl = `${model}Mpl`
        this[nmg] = 0
        this[mpl] = 0
        if (model === 'others') {
          this.othersName = ''
        }
      }
    },
    startSignProcess() {
      const finalStatus = 'Signing'
      const formData = new FormData()
      formData.append('status', finalStatus)
      this.$http.post(`operation/service-requests/service-form/${this.requestForm._id}/update/status`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(async response => {
          if (response.data.data) {
            await this.$emit('update:requestForm', response.data.data)
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || '',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    editForm() {
      if (this.requestForm.status === 'Not required') {
        const finalStatus = 'To prepare'
        const formData = new FormData()
        formData.append('status', finalStatus)
        this.$http.post(`operation/service-requests/service-form/${this.requestForm._id}/update/status`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
          .then(async response => {
            if (response.data.data) {
              await this.$emit('update:requestForm', response.data.data)
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: response.data.message || '',
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            }
          })
          .catch(error => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
      } else {
        this.$swal({
          title: 'Re-load Redemption of Imported Urn Form from Inventory Request?',
          html: 'The existing Inventory Items will be replaced with latest Inventory Request changes.',
          // eslint-disable-next-line global-require
          imageUrl: require('@/assets/images/icons/warning.png'),
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonText: 'No, go back',
          confirmButtonText: 'Yes, Proceed',
          customClass: {
            confirmButton: 'btn btn-primary ml-1',
            cancelButton: 'btn btn-outline-primary',
          },
          buttonsStyling: false,
          width: 600,
        })
          .then(async result => {
            if (result.value) {
              await this.getInventoryItems()
              this.editFormInOtherStatus = true
            }
          })
      }
    },
    manualIRIntegration() {
      this.$swal({
        title: 'Are you sure you want to integrate this form with IR workflow?',
        html: 'The form will draw data from Inventory Requests within this Service Request.',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/warning.png'),
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'No, go back',
        confirmButtonText: "Yes, I'm sure",
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            this.$http.get(`operation/service-requests/${this.serviceRequest._id}/update/ir-workflow`)
              .then(async response => {
                if (response.data.data) {
                  await this.$emit('update:serviceRequestTasks', response.data.data)
                  await this.getInventoryItems()
                } else {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: response.data.message || '',
                      icon: 'AlertTriangleIcon',
                      variant: 'danger',
                    },
                  })
                }
              })
              .catch(error => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              })
          }
        })
    },
    makeFormNotRequired() {
      this.$swal({
        title: 'Are you sure you want to ‘Mark as Not Required’ for this form?',
        html: 'The form status will change to ‘Not Required’, all information you have keyed in will be cleared.',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/warning.png'),
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'No, go back',
        confirmButtonText: "Yes, I'm sure",
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            const formData = new FormData()
            formData.append('status', 'Not required')
            this.$http.post(`operation/service-requests/service-form/${this.requestForm._id}/update/status`, formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
            })
              .then(async response => {
                if (response.data.data) {
                  await this.$emit('update:requestForm', response.data.data)
                  this.makeFormValues()
                  this.$swal({
                    title: 'Form Has Been Marked as Not Required',
                    // html: response.data.message || '',
                    // eslint-disable-next-line global-require
                    imageUrl: require('@/assets/images/icons/save.png'),
                    imageWidth: 80,
                    imageHeight: 80,
                    imageAlt: 'Custom Icon',
                    showCancelButton: false,
                    confirmButtonText: 'Okay',
                    customClass: {
                      confirmButton: 'btn btn-primary',
                    },
                    buttonsStyling: false,
                  })
                } else {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: response.data.message || '',
                      icon: 'AlertTriangleIcon',
                      variant: 'danger',
                    },
                  })
                }
              })
              .catch(error => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              })
          }
        })
    },
    closePurchaserSignModal() {
      this.$root.$emit('bv::hide::modal', 'purchaser-sign-modal', '')
    },
    clearPurchaserSign() {
      this.$refs.signaturePad.clearSignature()
    },
    savePurchaserSign() {
      const { data } = this.$refs.signaturePad.saveSignature()

      if (data) {
        this.$root.$emit('bv::hide::modal', 'purchaser-sign-modal', '')
        const purchaserSignObj = {
          key: 'purchaserSign',
          value: data,
        }
        if (this.editFormInOtherStatus) {
          this.purchaserSign = data
          this.isPurchaserSign = true
          purchaserSignObj.date = new Date()
          this.existingPurchaserSignObject = purchaserSignObj
        } else {
          const formData = new FormData()
          let allSigned = false
          if (this.verifiedSign) {
            allSigned = true
          }

          formData.append('allSigned', allSigned)
          formData.append('signature', JSON.stringify(purchaserSignObj))
          this.$http.post(`operation/service-requests/service-form/${this.requestForm._id}/store/sign`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
            .then(async response => {
              if (response.data.data) {
                await this.$emit('update:requestForm', response.data.data)
                this.makeFormValues()
                if (allSigned) {
                  this.$root.$emit('bv::show::modal', 'submit-form-modal', '')
                } else {
                  this.$swal({
                    title: 'Signature Saved',
                    html: response.data.message || '',
                    // eslint-disable-next-line global-require
                    imageUrl: require('@/assets/images/icons/save.png'),
                    imageWidth: 80,
                    imageHeight: 80,
                    imageAlt: 'Custom Icon',
                    showCancelButton: false,
                    confirmButtonText: 'Okay',
                    customClass: {
                      confirmButton: 'btn btn-primary',
                    },
                    buttonsStyling: false,
                  })
                }
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: response.data.message || '',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            })
        }
      }
    },
    closeVerifiedSignModal() {
      this.$root.$emit('bv::hide::modal', 'verified-sign-modal', '')
    },
    clearVerifiedSign() {
      this.$refs.signaturePad.clearSignature()
    },
    saveVerifiedSign() {
      const { data } = this.$refs.signaturePad.saveSignature()

      if (data) {
        this.$root.$emit('bv::hide::modal', 'verified-sign-modal', '')
        const verifiedSignObj = {
          key: 'verifiedSignSrc',
          value: data,
        }
        if (this.editFormInOtherStatus) {
          this.verifiedSignSrc = data
          this.verifiedSign = true
          verifiedSignObj.date = new Date()
          verifiedSignObj.name = this.user.name
          verifiedSignObj.admin = this.user._id
          this.existingVerifiedSignSrcObject = verifiedSignObj
        } else {
          const formData = new FormData()
          let allSigned = false
          if (this.isPurchaserSign) {
            allSigned = true
          }

          formData.append('allSigned', allSigned)
          formData.append('signature', JSON.stringify(verifiedSignObj))
          this.$http.post(`operation/service-requests/service-form/${this.requestForm._id}/store/sign`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
            .then(async response => {
              if (response.data.data) {
                await this.$emit('update:requestForm', response.data.data)
                this.makeFormValues()
                if (allSigned) {
                  this.$root.$emit('bv::show::modal', 'submit-form-modal', '')
                } else {
                  this.$swal({
                    title: 'Signature Saved',
                    html: response.data.message || '',
                    // eslint-disable-next-line global-require
                    imageUrl: require('@/assets/images/icons/save.png'),
                    imageWidth: 80,
                    imageHeight: 80,
                    imageAlt: 'Custom Icon',
                    showCancelButton: false,
                    confirmButtonText: 'Okay',
                    customClass: {
                      confirmButton: 'btn btn-primary',
                    },
                    buttonsStyling: false,
                  })
                }
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: response.data.message || '',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            })
        }
      }
    },
    closeCustomerNameModal() {
      this.$root.$emit('bv::hide::modal', 'customer-name-modal', '')
      if (!this.customerNameImage) {
        this.currentCustomerNameType = 'input'
      }
    },
    closeKinNameModal() {
      this.$root.$emit('bv::hide::modal', 'kin-name-modal', '')
      if (!this.kinNameImage) {
        this.currentKinNameType = 'input'
      }
    },
    submitSignedForm(option = null, send = true) {
      const formData = new FormData()
      formData.append('send', send)
      formData.append('customerEmail', this.customerEmailVal)
      formData.append('customerContact', this.customerMobileVal)
      if (option === 'edited') {
        formData.append('edited', 'yes')
      }
      if (this.tabActive === 'email') {
        formData.append('message', this.customerMessageValEmail)
      } else {
        formData.append('message', this.customerMessageValPhone)
      }
      formData.append('sendOptionType', this.tabActive)
      formData.append('formName', this.requestForm.formID.name)
      formData.append('url', `${window.location.origin}/operations/service-requests/form/${this.requestForm._id}/detail`)

      this.$http.post(`operation/service-requests/service-form/${this.requestForm._id}/generate-pdf`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(async response => {
          if (response.data.data) {
            await this.$emit('update:requestForm', response.data.data)
            this.$root.$emit('bv::hide::modal', 'submit-form-modal', '')

            this.makeFormValues()
            this.$toast({
              component: ToastificationContentCustom,
              props: {
                title: 'PDF is ready!',
                text: response.data.message,
                icon: 'CheckCircleIcon',
                variant: 'success',
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || '',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    resendSignedFormModal() {
      if (this.requestForm.pdfs.length) {
        this.$root.$emit('bv::show::modal', 'resend-form-modal', '')
      } else {
        this.$root.$emit('bv::show::modal', 'submit-form-modal', '')
      }
    },
    resendSignedForm() {
      const formData = new FormData()
      formData.append('customerEmail', this.customerEmailVal)
      formData.append('customerContact', this.customerMobileVal)
      if (this.tabActive === 'email') {
        formData.append('message', this.customerMessageValEmail)
      } else {
        formData.append('message', this.customerMessageValPhone)
      }
      formData.append('sendOptionType', this.tabActive)
      formData.append('formName', this.requestForm.formID.name)
      formData.append('url', `${window.location.origin}/operations/service-requests/form/${this.requestForm._id}/detail`)

      this.$http.post(`operation/service-requests/service-form/${this.requestForm._id}/resend-pdf`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          this.$toast({
            component: ToastificationContentCustom,
            props: {
              title: 'PDF is ready!',
              text: response.data.message,
              icon: 'CheckCircleIcon',
              variant: 'success',
            },
          })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    closeSubmitFormModal() {
      this.$root.$emit('bv::hide::modal', 'submit-form-modal', '')
    },
    closeResendFormModal() {
      this.$root.$emit('bv::hide::modal', 'resend-form-modal', '')
    },
    clearCustomerName() {
      this.customerNameImage = ''
      this.$refs.customerSignaturePad.clearSignature()
    },
    clearKinName() {
      this.kinNameImage = ''
      this.$refs.kinSignaturePad.clearSignature()
    },
    saveCustomerName() {
      const { data } = this.$refs.customerSignaturePad.saveSignature()
      if (data) {
        this.customerNameImage = data
        this.$root.$emit('bv::hide::modal', 'customer-name-modal', '')
        this.currentCustomerNameType = 'canvas'
      }
    },
    saveKinName() {
      const { data } = this.$refs.kinSignaturePad.saveSignature()
      if (data) {
        this.kinNameImage = data
        this.$root.$emit('bv::hide::modal', 'kin-name-modal', '')
        this.currentKinNameType = 'canvas'
      }
    },
    async handleClick(field, collapse) {
      if (this.requestForm.status === 'To prepare' || this.editFormInOtherStatus) {
        await this.$refs[collapse].updateVisible(true)
        this.$refs[field].focus()
      }
    },
    changeCustomerNameInput(type) {
      if (type === 'input') {
        this.$swal({
          title: 'Warning: Changing mode will result in the deletion of the handwriting.',
          html: 'Are you sure you want to continue?',
          // eslint-disable-next-line global-require
          imageUrl: require('@/assets/images/icons/warning.png'),
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonText: 'No, go back',
          confirmButtonText: "Yes, I'm sure",
          customClass: {
            confirmButton: 'btn btn-primary ml-1',
            cancelButton: 'btn btn-outline-primary',
          },
          buttonsStyling: false,
        })
          .then(async result => {
            if (result.value) {
              this.customerNameImage = ''
              this.currentCustomerNameType = type
            }
          })
      } else {
        this.currentCustomerNameType = type
        this.$root.$emit('bv::show::modal', 'customer-name-modal', '')
      }
    },
    changeKinNameInput(type) {
      if (type === 'input') {
        this.$swal({
          title: 'Warning: Changing mode will result in the deletion of the handwriting.',
          html: 'Are you sure you want to continue?',
          // eslint-disable-next-line global-require
          imageUrl: require('@/assets/images/icons/warning.png'),
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonText: 'No, go back',
          confirmButtonText: "Yes, I'm sure",
          customClass: {
            confirmButton: 'btn btn-primary ml-1',
            cancelButton: 'btn btn-outline-primary',
          },
          buttonsStyling: false,
        })
          .then(async result => {
            if (result.value) {
              this.kinNameImage = ''
              this.currentKinNameType = type
            }
          })
      } else {
        this.currentKinNameType = type
        this.$root.$emit('bv::show::modal', 'kin-name-modal', '')
      }
    },
    submitSaveFormConfirmation() {
      if (this.requestForm.status === 'Signed and Sent') {
        this.$root.$emit('bv::show::modal', 'edit-form-modal', '')
      } else {
        this.submitSaveForm()
      }
    },
    cancelEditing() {
      this.$root.$emit('bv::hide::modal', 'edit-form-modal', '')
      // this.editFormInOtherStatus = false
      // this.makeFormValues()
    },
    submitSaveForm(option = null, submit = false, send = true) {
      this.$refs.serviceRequestFormSave.validate().then(success => {
        let hasCustomerImage = true
        if (this.currentCustomerNameType === 'canvas' && !this.customerNameImage) {
          hasCustomerImage = false
          this.customerNameImageError = true
        }
        // let hasKinImage = true
        // if (this.currentKinNameType === 'canvas' && !this.kinNameImage) {
        //   hasKinImage = false
        //   this.kinNameImageError = true
        // }
        if ((option && option === 'saveOnly') || (success && hasCustomerImage)) {
          const formData = new FormData()
          if (option && option === 'readyToSign') {
            formData.append('readyToSign', true)
          }
          const valueArray = []
          let srValueArray = this.serviceRequest.formValues
          const sfValueObject = {}
          const srValueObject = {}
          const customerNameObj = {
            key: 'customerName',
          }
          if (this.currentCustomerNameType === 'input') {
            customerNameObj.value = this.customerName
          } else {
            customerNameObj.value = this.customerNameImage
          }
          srValueArray = srValueArray.filter(obj => obj.key !== customerNameObj.key).concat(customerNameObj)

          const customerNRICObj = {
            key: 'customerNRIC',
            value: this.customerNRIC,
          }
          srValueArray = srValueArray.filter(obj => obj.key !== customerNRICObj.key).concat(customerNRICObj)

          const kinNameObj = {
            key: 'kinName',
          }
          if (this.currentKinNameType === 'input') {
            kinNameObj.value = this.kinName
          } else {
            kinNameObj.value = this.kinNameImage
          }
          srValueArray = srValueArray.filter(obj => obj.key !== kinNameObj.key).concat(kinNameObj)

          const kinNRICObj = {
            key: 'kinNRIC',
            value: this.kinNRIC,
          }
          srValueArray = srValueArray.filter(obj => obj.key !== kinNRICObj.key).concat(kinNRICObj)

          srValueObject.fileNo = this.fileNo

          const nicheLotObj = {
            key: 'nicheLot',
            value: this.nicheLot,
          }
          valueArray.push(nicheLotObj)

          const urnFileNoObj = {
            key: 'urnFileNo',
            value: this.urnFileNo,
          }
          valueArray.push(urnFileNoObj)

          const relatedFileNoObj = {
            key: 'relatedFileNo',
            value: this.relatedFileNo,
          }
          valueArray.push(relatedFileNoObj)

          const numberOfUnitObj = {
            key: 'numberOfUnit',
            value: this.numberOfUnit,
          }
          valueArray.push(numberOfUnitObj)

          const inventoryItemsObj = {
            key: 'inventoryItems',
            value: this.inventoryItems,
          }
          valueArray.push(inventoryItemsObj)

          const splitQuantityObj = {
            key: 'splitQuantity',
            value: this.splitQuantity,
          }
          valueArray.push(splitQuantityObj)

          // const dgcwbsObj = {
          //   key: 'dgcwbs',
          //   value: this.dgcwbs,
          // }
          // valueArray.push(dgcwbsObj)

          // const dgcwbsNmgObj = {
          //   key: 'dgcwbsNmg',
          //   value: this.dgcwbsNmg,
          // }
          // valueArray.push(dgcwbsNmgObj)

          // const dgcwbsMplObj = {
          //   key: 'dgcwbsMpl',
          //   value: this.dgcwbsMpl,
          // }
          // valueArray.push(dgcwbsMplObj)

          // const lgcwbsObj = {
          //   key: 'lgcwbs',
          //   value: this.lgcwbs,
          // }
          // valueArray.push(lgcwbsObj)

          // const lgcwbsNmgObj = {
          //   key: 'lgcwbsNmg',
          //   value: this.lgcwbsNmg,
          // }
          // valueArray.push(lgcwbsNmgObj)

          // const lgcwbsMplObj = {
          //   key: 'lgcwbsMpl',
          //   value: this.lgcwbsMpl,
          // }
          // valueArray.push(lgcwbsMplObj)

          // const lcwbsObj = {
          //   key: 'lcwbs',
          //   value: this.lcwbs,
          // }
          // valueArray.push(lcwbsObj)

          // const lcwbsNmgObj = {
          //   key: 'lcwbsNmg',
          //   value: this.lcwbsNmg,
          // }
          // valueArray.push(lcwbsNmgObj)

          // const lcwbsMplObj = {
          //   key: 'lcwbsMpl',
          //   value: this.lcwbsMpl,
          // }
          // valueArray.push(lcwbsMplObj)

          // const pcllObj = {
          //   key: 'pcll',
          //   value: this.pcll,
          // }
          // valueArray.push(pcllObj)

          // const pcllNmgObj = {
          //   key: 'pcllNmg',
          //   value: this.pcllNmg,
          // }
          // valueArray.push(pcllNmgObj)

          // const pcllMplObj = {
          //   key: 'pcllMpl',
          //   value: this.pcllMpl,
          // }
          // valueArray.push(pcllMplObj)

          // const byllObj = {
          //   key: 'byll',
          //   value: this.byll,
          // }
          // valueArray.push(byllObj)

          // const byllNmgObj = {
          //   key: 'byllNmg',
          //   value: this.byllNmg,
          // }
          // valueArray.push(byllNmgObj)

          // const byllMplObj = {
          //   key: 'byllMpl',
          //   value: this.byllMpl,
          // }
          // valueArray.push(byllMplObj)

          // const roObj = {
          //   key: 'ro',
          //   value: this.ro,
          // }
          // valueArray.push(roObj)

          // const roNmgObj = {
          //   key: 'roNmg',
          //   value: this.roNmg,
          // }
          // valueArray.push(roNmgObj)

          // const roMplObj = {
          //   key: 'roMpl',
          //   value: this.roMpl,
          // }
          // valueArray.push(roMplObj)

          // const pjObj = {
          //   key: 'pj',
          //   value: this.pj,
          // }
          // valueArray.push(pjObj)

          // const pjNmgObj = {
          //   key: 'pjNmg',
          //   value: this.pjNmg,
          // }
          // valueArray.push(pjNmgObj)

          // const pjMplObj = {
          //   key: 'pjMpl',
          //   value: this.pjMpl,
          // }
          // valueArray.push(pjMplObj)

          // const rjObj = {
          //   key: 'rj',
          //   value: this.rj,
          // }
          // valueArray.push(rjObj)

          // const rjNmgObj = {
          //   key: 'rjNmg',
          //   value: this.rjNmg,
          // }
          // valueArray.push(rjNmgObj)

          // const rjMplObj = {
          //   key: 'rjMpl',
          //   value: this.rjMpl,
          // }
          // valueArray.push(rjMplObj)

          // const othersObj = {
          //   key: 'others',
          //   value: this.others,
          // }
          // valueArray.push(othersObj)

          // const othersNameObj = {
          //   key: 'othersName',
          //   value: this.othersName,
          // }
          // valueArray.push(othersNameObj)

          // const othersNmgObj = {
          //   key: 'othersNmg',
          //   value: this.othersNmg,
          // }
          // valueArray.push(othersNmgObj)

          // const othersMplObj = {
          //   key: 'othersMpl',
          //   value: this.othersMpl,
          // }
          // valueArray.push(othersMplObj)

          let verifiedSignVal = 0
          let purchaserSignVal = 0

          if (this.existingVerifiedSignSrcObject.value) {
            verifiedSignVal = 1
            valueArray.push(this.existingVerifiedSignSrcObject)
          }
          if (this.existingPurchaserSignObject.value) {
            purchaserSignVal = 1
            valueArray.push(this.existingPurchaserSignObject)
          }

          let allSigned = false
          if (verifiedSignVal && purchaserSignVal) {
            allSigned = true
          }

          // let valueChanged = false
          // if (this.requestForm.status === 'Signed and Sent') {
          //   const difference = valueArray.filter(({ value: id1 }) => !this.requestForm.values.some(({ value: id2 }) => id2 === id1))
          //   if (difference.length) {
          //     const otherValueChanged = difference.find(o => !['installationDate', 'installationTime'].includes(o.key))
          //     if (otherValueChanged) {
          //       valueChanged = true
          //     }
          //   }
          // }

          formData.append('values', JSON.stringify(valueArray))
          formData.append('srValues', JSON.stringify(srValueArray))
          formData.append('sfValues', JSON.stringify(sfValueObject))
          formData.append('srValueObject', JSON.stringify(srValueObject))
          formData.append('allSigned', allSigned)
          formData.append('currentStatus', this.requestForm.status)
          formData.append('formName', this.requestForm.formID.name)
          formData.append('serviceRequest', this.serviceRequest._id)
          formData.append('serviceForm', this.serviceRequest.serviceForm._id)
          formData.append('url', `${window.location.origin}/operations/service-requests/form/${this.requestForm._id}/detail`)
          this.$http.post(`operation/service-requests/service-form/${this.requestForm._id}/store`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
            .then(async response => {
              if (response.data.data) {
                await this.$emit('update:requestForm', response.data.data)
                await this.$emit('update:serviceRequest', response.data.sr)
                this.makeFormValues()
                this.editFormInOtherStatus = false
                if (option && option === 'edited' && response.data.data.status === 'Signed and Sent' && submit) {
                  this.submitSignedForm('edited', send)
                } else if (response.data.data.status === 'Signing' && allSigned) {
                  this.$root.$emit('bv::show::modal', 'submit-form-modal', '')
                } else {
                  this.$swal({
                    title: 'Form Data Saved',
                    html: response.data.message || '',
                    // eslint-disable-next-line global-require
                    imageUrl: require('@/assets/images/icons/save.png'),
                    imageWidth: 80,
                    imageHeight: 80,
                    imageAlt: 'Custom Icon',
                    showCancelButton: false,
                    confirmButtonText: 'Okay',
                    customClass: {
                      confirmButton: 'btn btn-primary',
                    },
                    buttonsStyling: false,
                  })
                }
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: response.data.message || '',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            })
        } else {
          const items = document.getElementsByClassName('is-invalid')
          if (items && items.length) {
            // window.scrollTo({
            //   top: items[0].offsetHeight + 100,
            //   behavior: 'smooth',
            // })
            items[0].scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'center',
            })
          }
        }
      })
    },
  },
}
</script>

<style lang="scss">
.alert p {
  font-weight: 400 !important;
}
</style>
